import {
    mergeTranslations,
    TranslationMessages as BaseTranslationMessages,
} from 'react-admin';
import finnishMessages from 'ra-language-finnish';
import { RaTreeTranslationMessages } from '@react-admin/ra-tree';

export interface TranslationMessages
    extends RaTreeTranslationMessages, BaseTranslationMessages {}

const customFinnishMessages: TranslationMessages = mergeTranslations(
    finnishMessages,
    {
        'ra-form-layout': {
            action: {
                next: 'Seuraava',
                previous: 'Edellinen',
            },
        },
        'ra-tree': {
            action: {
                add_root: 'Add a category of products',
            },
        },
        'ra-search': {
            result: `1 result |||| %{smart_count} results`,
        },
        'ra-realtime': {
            notification: {
                lock: {
                    lockedByMe: 'Lukittu sinulle',
                    lockedBySomeoneElse: 'Lukittu jollekin toiselle',
                    unlocked: 'Lukitus vapautettu',
                },
            },
        },
        'ra-preferences': {
            action: {
                choose_columns: 'Valitse sarake',
                toggle_theme: 'Vaihda teema',
            },
        },
        ra: {
            action: {
                select_columns: 'Valitse sarakkeet',
                toggle_theme: 'Vaihda teema',
                copy: 'Kopioi leikepöydälle',
            },
            page: {
                empty: 'Ei tuloksia',
            },
            saved_queries: {
                label: 'Tallennetut',
                query_name: 'Kyselyn nimi',
                new_label: 'Tallenna nykyinen kysely',
                new_dialog_title: 'Tallenna nykyinen kysely nimellä',
                remove_label: 'Poista tallennettu kysely',
                remove_label_with_name: 'Poista kysely "%{name}"',
                remove_dialog_title: 'Poista tallennettu kysely?',
                remove_message: 'Oletko varma, että haluat poistaa kyselyn?',
                help: 'Suodata ensin lista ja tallenna kysely tulevaan käyttöä varten.',
            },
        },
        actions: {
            export: 'Vie Exceliin',
            login_as: {
                column_label: 'Esikatselu',
                teacher_tooltip: 'Kirjaudu opettajana',
                student_tooltip: 'Kirjaudu opiskelijana',
                pupil_tooltip: 'Kirjaudu oppilaana',
                user_inactive: 'Käyttäjä ei ole aktiivinen',
                profile_locked: 'Profiili on lukittu',
                login_not_allowed: 'Kirjautuminen ei ole sallittu',
                access_starts_on: 'Voimassaoloa alkaa %{date}',
                access_expired_on: 'Voimassaoloa päättyi %{date}',
            },
            copy_access_token: {
                column_label: 'Lisätoiminto',
                tooltip: 'Kopioi access_token leikepöydälle (observer)',
                copied: 'Access_token kopioitu leikepöydälle',
                user_inactive: 'Käyttäjä ei ole aktiivinen',
            },
        },
        notifications: {
            SAVE_SUCCESS: 'Tallennettu',
            MPASS_REMOVED: 'MPASS-tunnus poistettu',
            ACTION_ERROR: 'Toiminto epäonnistui',
            SESSION_REMOVED: 'Istunto poistettu ja käyttäjä kirjattu ulos.',
            KV_USER_NOT_FOUND:
                'Käyttäjää ei löydy Kirjavälityksestä tällä tunnisteella',
            KV_EMAIL_ALREADY_USED: 'Sähköposti on jo käytössä Storialla',
            NETWORK_ERRROR: 'Verkkovirhe',
            EMAIL_ALREADY_USED: 'Sähköposti on jo käytössä',
            EXPORT_ERROR: 'Virhe tallennettaessa tiedostoa',
        },
        menu: {
            audience: 'Käyttäjät',
            sales: 'Testi',
            catalog: 'Catalog',
            customers: 'Customers',
            hallinta: 'Hallinta',
        },
        hallinta: {
            tabs: {
                aws_overview: 'AWS Yleisnäkymä',
                secrets: 'Secrets Manager',
                jwt_keys: 'JWT-avaimet',
                oauth_clients: 'OAuth-asiakkaat',
                api_configs: 'API-asetukset',
                settings: 'Asetukset',
                tests: 'Testit',
            },
            settings: {
                campaign_csv_email: 'Kampanjoiden CSV-viennin oletusvastaanottaja',
                title: 'Listausten asetukset',
                turnstile_title: 'Novan Turnstile-turvatarkistus',
                turnstile_enabled: 'Turnstile-tarkistus käytössä kirjautumisissa',
                turnstile_enabled_help:
                    'Kytkee Turnstile-tarkistuksen päälle tai pois opettaja-, oppilas- ja opiskelija-Novan kirjautumisessa tässä ympäristössä. Ei vaikuta opiskelijan rekisteröitymisen tarkistukseen. Tuotannossa poistaminen heikentää bottisuojausta.',
                turnstile_disable_confirm_title:
                    'Poistetaanko Turnstile kirjautumisista?',
                turnstile_disable_confirm_content:
                    'Turnstile-tarkistus poistuu käytöstä tämän ympäristön Nova-kirjautumisissa. Opiskelijan rekisteröitymisen tarkistus säilyy käytössä. Tämä heikentää kirjautumisten bottisuojausta.',
                turnstile_dev_scenario: 'Kirjautumisten testiskenaario Devissä',
                turnstile_dev_warning:
                    'Testiskenaario vaikuttaa kaikkeen Nova-kirjautumiseen Devissä, ei opiskelijan rekisteröitymiseen. Palauta Normal-tilaan testauksen jälkeen.',
                turnstile_credentials_help:
                    'AWS-avaimia käytetään Nova-kirjautumisiin ja opiskelijan rekisteröitymiseen. Avaimia voi muokata erillisessä ikkunassa. Ne ladataan AWS Secrets Managerista palveluiden käynnistyessä, joten avainmuutos edellyttää niitä käyttävien palveluiden uudelleenkäynnistystä.',
                turnstile_keys_edit: 'Muokkaa AWS-avaimia',
                turnstile_keys_title: 'Turnstile-avaimet AWS Secrets Managerissa',
                turnstile_keys_current_env: 'Avaimia voi muokata vain nykyisen palvelinympäristön välilehdellä.',
                turnstile_keys_help: 'Vain muutetut roolit tallennetaan. Muut AWS-salaisuudet säilyvät ennallaan. Salaisista avaimista näytetään vain neljä viimeistä merkkiä; lyhyet avaimet peitetään kokonaan.',
                turnstile_keys_current_secret: 'Nykyinen secret key',
                turnstile_keys_restart: 'Tallennus muuttaa AWS-salaisuutta, ei käynnissä olevia palveluita. Käynnistä OIDC- ja rekisteröitymispalvelut uudelleen. Opiskelijan site keyn muuttuessa päivitä myös rekisteröitymisfrontin NEXT_PUBLIC_TURNSTILE_SITE_KEY.',
                turnstile_keys_keep_secret: 'Avain on asetettu. Jätä tyhjäksi säilyttääksesi nykyisen salaisen avaimen.',
                turnstile_keys_missing_secret: 'Salaista avainta ei ole asetettu.',
                turnstile_keys_pair_required: 'Anna sekä site key että sitä vastaava secret key, kun lisäät tai vaihdat site keyn. Avaimia ei voi poistaa tällä lomakkeella.',
                turnstile_keys_saved: 'Avaimet tallennettu AWS:ään. Käynnistä niitä käyttävät palvelut uudelleen.',
                turnstile_keys_error: 'AWS-avainten lukeminen tai tallennus epäonnistui. Tarkista käyttöoikeudet ja AWS-salaisuuden rakenne.',
                turnstile_keys_conflict: 'AWS-salaisuus on muuttunut. Sulje ja avaa ikkuna uudelleen ennen tallennusta.',
                turnstile_role_teacher: 'Opettaja',
                turnstile_role_pupil: 'Oppilas',
                turnstile_role_student: 'Opiskelija',
                turnstile_scenario_normal: 'Normal — käytä Dev-sovelluksen avaimia',
                turnstile_scenario_always_pass:
                    'Cloudflare-test avaimet — widget ja validointi onnistuvat',
                turnstile_scenario_always_fail:
                    'Cloudflare-test avaimet — widget ja validointi epäonnistuvat',
                turnstile_scenario_server_failure:
                    'Cloudflare-test avaimet — palvelinvalidointi epäonnistuu',
                turnstile_scenario_duplicate_token:
                    'Cloudflare-test avaimet — token on jo käytetty',
                turnstile_scenario_interactive:
                    'Cloudflare-test avaimet — interaktiivinen haaste',
                turnstile_scenario_client_error:
                    'Simuloi widgetin selainvirhettä',
                turnstile_scenario_token_expired:
                    'Simuloi vanhentunutta tokenia',
                turnstile_scenario_pending:
                    'Simuloi jumiin jäävää tarkistusta',
                turnstile_scenario_missing_token:
                    'Simuloi puuttuvaa tokenia',
                turnstile_scenario_siteverify_unreachable:
                    'Simuloi yhteysvirhettä Cloudflaren validointiin',
                list_sessions: 'Hae istuntotiedot listauksissa',
                list_sessions_help:
                    'Kun pois päältä, käyttäjälistaukset (opettaja/oppilas/opiskelija/käyttäjä) eivät hae istuntotietoja Redisistä. Nopeuttaa listausta kuormituspiikeissä; "online"-tieto ei tällöin näy.',
                user_data_recheck_title: 'Käyttäjätietojen tarkistusväli',
                user_data_recheck_help:
                    'Kuinka monen vuorokauden ajan käyttäjän tai koulusuhteen viimeksi vahvistetut tiedot pysyvät "up-to-date"-tilassa ennen kuin user_data_state muuttuu "stale"-tilaan. Oletus 248 vrk (~8 kk). Sallittu 1–3650.',
                user_data_recheck_days_invalid:
                    'Anna kokonaisluku väliltä 1–3650',
                list_stale_info: 'Näytä tietojen vanhentumistila listauksissa',
                list_stale_info_help:
                    'Kun päällä, opettaja-/oppilas-/opiskelijalistaukset ja -muokkausnäkymät laskevat ja näyttävät user_data_state-tiedon ("up-to-date"/"stale"). Kun pois, tietoa ei lasketa eikä palauteta.',
                security_title: 'Tunnistautuminen',
                basic_login:
                    'Salli perustunnistautuminen (käyttäjätunnus/salasana)',
                basic_login_help:
                    'Deprikoitu — ensisijainen kirjautuminen on AdLogin (Entra). Kun pois päältä, backend hylkää käyttäjätunnus/salasana-kirjautumisen (403). Ota käyttöön väliaikaisesti vain jos AdLogin ei toimi. Täydessä AdLogin-katkossa (et pääse tänne kirjautumaan) käytä ympäristömuuttujaa BASIC_LOGIN_ENABLED=true.',
                save: 'Tallenna',
                saved: 'Asetus tallennettu',
                error: 'Asetuksen tallennus epäonnistui',
                invitation_ttl: 'Opettajan kutsun voimassaolo (vrk)',
                invitation_ttl_help:
                    'Kuinka monen vuorokauden ajan kutsu näytetään voimassa olevana (kirjekuoren tila ja aktivointilinkki) ja toimitustilaa tarkistetaan. Vaikuttaa kaikkiin kutsuihin, myös vanhoihin. Sallittu 1–365.',
                invitation_ttl_invalid: 'Anna kokonaisluku väliltä 1–365',
                invitation_ttl_enforced: 'Estä vanhentuneet kutsut (backend)',
                invitation_ttl_enforced_help:
                    'Kun päällä, backend hylkää vanhentuneen kutsun aktivoinnin ja tarkistuksen (luonti + voimassaolo vrk). Koskee kaikkia kutsuja, myös vanhoja. Ota käyttöön vasta kun Nova-frontend näyttää voimassaolon.',
                invitation_title: 'Kutsujen asetukset',
                auto_resend: 'Automaattinen uudelleenlähetys',
                auto_resend_enabled: 'Automaattinen uudelleenlähetys käytössä',
                auto_resend_enabled_help:
                    'Kun päällä, kutsut lähetetään automaattisesti uudelleen porrastetun aikataulun ja valitun kohteen mukaan. Oletuksena pois.',
                auto_resend_mode: 'Mitkä kutsut lähetetään uudelleen',
                auto_resend_mode_all: 'Kaikki — muistutus kaikille odottaville',
                auto_resend_mode_stuck_failed:
                    'Jumiutuneet / epäonnistuneet (ei toimitetut)',
                auto_resend_schedule: 'Aikataulu (vrk, pilkuilla)',
                auto_resend_schedule_help:
                    'esim. 3, 10, 30 = 1. yritys 3 vrk edellisestä lähetyksestä, 2. yritys 10 vrk, 3. yritys 30 vrk. Alkioiden määrä = enimmäisyritykset. 1–20 alkiota, kukin 1–365.',
                auto_resend_schedule_invalid:
                    'Anna 1–20 kokonaislukua (kukin 1–365) pilkuilla eroteltuna',
                license_cache_title:
                    'Kumppani-API ja lisenssitarkistuksen välimuisti',
                license_cache_subtitle:
                    'Lisenssitarkistus (GET /license/user/{guid})',
                license_data_cache_enabled: 'Datacache käytössä',
                license_data_cache_enabled_help:
                    'Kun pois päältä, lisenssitarkistus ohittaa uuden guid-avaimisen datacachen kokonaan ja käyttää aina alkuperäistä, filtterillä varustettua kantakyselyä (ei koske alla olevaa TTL-asetusta). Turvallinen tapa perua uusi toiminto tuotannossa, jos siinä ilmenee ongelmia.',
                license_cache_ttl: 'Välimuistin TTL (s)',
                license_cache_ttl_help:
                    'Kuinka pitkään kumppani-API:n lisenssitarkistuksen (/license/user/{guid}) koko käyttäjäkohtainen lisenssilista pidetään Valkey-välimuistissa. Ennakoiva päivitys tapahtuu materiaalin klikkauksen yhteydessä (prewarm), tämä on varmuuden vuoksi asetettu takaraja. 0 = välimuisti pois käytöstä. Sallittu 0–3600.',
                license_cache_ttl_invalid: 'Anna kokonaisluku väliltä 0–3600',
                license_cache_prewarm: 'Ennakoiva päivitys (prewarm) käytössä',
                license_cache_prewarm_help:
                    'Kun päällä, materiaalin klikkaus (jos materiaalilla on prewarm-lippu) päivittää käyttäjän lisenssivälimuistin ennakoivasti ennen kumppani-API:n kutsua. Kytke pois vain jos prewarm aiheuttaa ylimääräistä kuormaa - välimuisti toimii silti TTL:n mukaisesti.',
                teacher_cache_subtitle:
                    'Opettajan tiedot (GET /teacher/{guid})',
                teacher_data_cache_enabled: 'Datacache käytössä',
                teacher_data_cache_enabled_help:
                    'Kun pois päältä, opettajan tietojen haku ohittaa Valkey-datacachen kokonaan (ttl pakotetaan nollaan) ja hakee tiedot aina suoraan kannasta. Turvallinen tapa perua uusi toiminto tuotannossa, jos siinä ilmenee ongelmia.',
                teacher_cache_ttl: 'Välimuistin TTL (s)',
                teacher_cache_ttl_help:
                    'Kuinka pitkään opettajan koko tietorakenne (luokat, oppilaat) pidetään Valkey-välimuistissa (teacher_full_data_{guid}). 0 = välimuisti pois käytöstä. Sallittu 0–604800 (7 vrk).',
                teacher_cache_ttl_invalid: 'Anna kokonaisluku väliltä 0–604800',
                teacher_cache_prewarm: 'Ennakoiva päivitys (prewarm) käytössä',
                teacher_cache_prewarm_help:
                    'Kun päällä, materiaalin klikkaus (jos materiaalilla on prewarm-lippu) päivittää opettajan tietovälimuistin ennakoivasti. Kytke pois vain jos prewarm aiheuttaa ylimääräistä kuormaa.',
                teacher_cache_invalidate_on:
                    'Ryhmätapahtumien välimuistipäivitys käytössä',
                teacher_cache_invalidate_on_help:
                    'Kun päällä, ryhmän/oppilaan/opiskelijan muutokset (liittyminen, poisto, TEACHER_UPDATED) päivittävät opettajan välimuistin automaattisesti taustalla. Kytke pois esim. lukukauden/jakson vaihtuessa jos ryhmätapahtumien määrä kuormittaa kantaa liikaa - tällöin välimuisti vanhenee vain TTL:n mukaan. Ei vaikuta ennakoivaan lämmitykseen (prewarm) eikä opettajan poiston yhteydessä tehtävään cachen tyhjennykseen.',
                product_mem_cache_subtitle:
                    'Tuotecachen prosessimuisti (all_products/all_student_products/all_pupil_products)',
                product_mem_cache_broadcast_enabled: 'Taustapäivitys käytössä',
                product_mem_cache_broadcast_enabled_help:
                    'Kun päällä, jokainen backend-prosessi päivittää oman prosessimuistinsa tuotelistan automaattisesti heti kun pg_cron on rakentanut Valkey-cachen uudelleen (n. 10 min välein) - estää prosessimuistin oma-aikaisen vanhenemisen (STALE) joka muuten osuisi satunnaiseen asiakaspyyntöön. Kytke pois vain jos broadcast aiheuttaa ongelmia - prosessimuisti toimii silti oman (pidemmän varmuusvara-) TTL:n mukaan.',
                diagnostic_title: 'APM-diagnostiikka',
                diagnostic_global_enabled:
                    'APM-diagnostiikka käytössä (kaikki backendit)',
                diagnostic_global_enabled_help:
                    'Pääkytkin. Kun pois päältä, mikään backend ei kerää diagnostiikkaa, vaikka yksittäinen backend olisi merkitty päälle alla.',
                diagnostic_backend: 'Backend',
                diagnostic_enabled:
                    'Diagnostic-telemetria käytössä kumppani-API:ssa',
                diagnostic_detail: 'Keräyksen tarkkuus',
                diagnostic_detail_basic:
                    'Normaali keräys: HTTP-, Express-, tietokanta- ja ulkoisten HTTP-kutsujen spanit. Ei Node-diagnostiikan lisämittareita.',
                diagnostic_detail_diagnostic:
                    'Ongelmanselvitys: basic-keräyksen lisäksi event loop-, CPU-, heap- ja RSS-mittarit valituilta pyynnöiltä.',
                diagnostic_detail_verbose:
                    'Laajin diagnostiikka ongelmatilanteisiin. Voi lisätä keräyksen määrää ja suorituskykyvaikutusta.',
                diagnostic_paths: 'Valittavat endpointit',
                diagnostic_all_paths: 'Kaikki polut (tämä backend)',
                diagnostic_all_paths_help:
                    'Kerää diagnostiikkaa kaikilta backendin endpointeilta reittikohtaisen valinnan sijaan. Käytä vain rajattuun, väliaikaiseen selvitykseen - vaatii voimassaoloajan.',
                diagnostic_expires: 'Diagnostiikka päättyy',
                diagnostic_help:
                    'Oletuksena pois päältä. Rajaa keräys vain ongelman selvittämiseen tarvittaviin kumppani-API:n polkuihin. Tyhjä päättymisaika jättää asetuksen voimaan, kunnes se kytketään pois.',
                diagnostic_paths_invalid:
                    'Anna vähintään yksi /-alkuinen polku',
                diagnostic_all_paths_requires_expiry:
                    'Kaikki polut -tila vaatii voimassaoloajan (expires_at)',
                save_as_defaults: 'Tallenna nykyiset oletukseksi',
                save_as_defaults_confirm_title: 'Tallenna oletukset?',
                save_as_defaults_confirm_content:
                    'Nykyiset ajossa olevat asetukset tallennetaan palautuspisteeksi. Ylikirjoittaa aiemmin tallennetut oletukset.',
                defaults_saved: 'Nykyiset asetukset tallennettu oletuksiksi',
                reset_to_defaults: 'Palauta oletukset',
                reset_to_defaults_confirm_title: 'Palautetaanko oletukset?',
                reset_to_defaults_confirm_content:
                    'Kaikki ajossa olevat asetukset korvataan viimeksi tallennetuilla oletuksilla. Toimintoa ei voi perua.',
                reset_done: 'Asetukset palautettu oletuksiin',
                read_only_env_notice:
                    'Näytetään toisen ympäristön asetukset - vain luku. Muokkaus on mahdollista vain tuotannosta, ja se vaikuttaa kohdeympäristöön vasta seuraavan yöllisen tietokantapalautuksen jälkeen.',
            },
            api_configs: {
                fields: {
                    application_name: 'Sovellus',
                    key: 'API-avain',
                    name: 'Nimi',
                    type: 'Tyyppi',
                    is_default: 'Oletus',
                    role: 'Rooli',
                    policy: 'Käytäntö',
                    adminrights: 'Ylläpito-oikeudet',
                    allowed_swaggers: 'Sallitut swagger-tiedostot',
                    userrights: 'Käyttöoikeudet (JSON)',
                    jwt_algorithm: 'Algoritmi',
                    jwt_ttl: 'Token TTL',
                    oidc_code_ttl: 'OIDC-koodin TTL',
                    session_config: 'Istuntoasetukset (JSON)',
                    login_config: 'Kirjautumisasetukset (JSON)',
                    scope: 'Scope',
                    status: 'Tila',
                },
                sections: {
                    basic: 'Perustiedot',
                    jwt: 'JWT-asetukset',
                    json_config: 'Asetukset',
                    jwt_keys: 'Liitetyt JWT-avaimet',
                    oauth_clients: 'Liitetyt OAuth-asiakkaat',
                },
                actions: {
                    back: 'API-asetukset',
                },
                no_jwt_keys: 'Ei liitettyjä JWT-allekirjoitusavaimia.',
                no_oauth_clients: 'Ei liitettyjä OAuth-asiakkaita.',
            },
            oauth_clients: {
                fields: {
                    name: 'Nimi',
                    type: 'Tyyppi',
                    client_id: 'Client ID',
                    client_secret: 'Client Secret',
                    api_key: 'API-avain',
                    env: 'Ympäristö',
                    status: 'Tila',
                    theme: 'Teema',
                    back_channel_logout_uri: 'Back-channel Logout URI',
                    applications: 'Sovellukset',
                    created: 'Luotu',
                    modified: 'Muokattu',
                    guid: 'GUID',
                    basic_auth_badge: 'Basic Auth',
                },
                status: {
                    active: 'Aktiivinen',
                    disabled: 'Poistettu käytöstä',
                },
                tabs: {
                    basic_info: 'Perustiedot',
                    applications: 'Sovellukset',
                },
                sections: {
                    info_config: 'Asetukset',
                    info_config_openid: 'OpenID Asetukset',
                    basic_auth: 'Basic Auth -asetukset',
                },
                actions: {
                    back: 'OAuth-asiakkaat',
                    delete: 'Poista',
                    add_application: 'Lisää sovellus',
                },
                bulk_delete: {
                    button: 'Poista (%{count})',
                    confirm_title: 'Vahvista pysyvä poisto',
                    confirm_permanent:
                        '%{count} valittua asiakasta on tilassa "Poistettu käytöstä" ja ne poistetaan pysyvästi kaikkine sovelluksineen. Tätä toimintoa ei voi peruuttaa.',
                    confirm_soft:
                        '%{count} aktiivista asiakasta poistetaan käytöstä.',
                    cancel: 'Peruuta',
                    confirm: 'Poista',
                    success_disabled: '%{count} asiakas(ta) poistettu käytöstä',
                    success_permanent: '%{count} poistettu pysyvästi',
                    error: 'Virhe poistettaessa asiakkaita',
                },
                applications: {
                    title: 'Sovellukset',
                    title_openid: 'OpenID Sovellus asetukset',
                    no_links: 'Ei sovelluksia',
                    fields: {
                        application: 'Sovellus',
                        api_key_override: 'API-avain (ylikirjoitus)',
                        redirect_uris: 'Redirect URI:t',
                        login_uri: 'Login URI',
                        authorize_uris: 'Authorize URI:t',
                        scope: 'Scope',
                        response_type: 'Response Type',
                        access_token_name: 'Access Token Name',
                        use_refresh_token: 'Käytä Refresh Tokenia',
                        status: 'Tila',
                        actions: 'Toiminnot',
                    },
                    dialog: {
                        add_title: 'Lisää sovellus',
                        edit_title: 'Muokkaa sovellusta',
                        application_guid: 'Sovelluksen GUID',
                        redirect_uris_helper: 'Yksi URI per rivi',
                        uris_helper: 'Yksi URI per rivi',
                        comma_separated_helper: 'Pilkuilla erotettu',
                        cancel: 'Peruuta',
                        save: 'Tallenna',
                        add: 'Lisää',
                    },
                    confirm_delete: 'Poista tämä sovellus?',
                    notify: {
                        removed: 'Sovellus poistettu',
                        updated: 'Sovellus päivitetty',
                        added: 'Sovellus lisätty',
                    },
                },
                audit: 'Audit',
            },
            tests: {
                title: 'Testiskenaariot',
                create: 'Luo testiskenaario',
                no_scenarios: 'Ei testiskenaarioita',
                delete_confirm:
                    'Haluatko varmasti poistaa testiskenaarion "%{name}"? Kaikki testikäyttäjät ja ryhmät poistetaan.',
                delete_success: 'Testiskenaario poistettu',
                create_success: 'Testiskenaario luotu',
                persist_success:
                    'Testiskenaario tallennettu S3:een — palautuu yöpäivityksen jälkeen',
                unpersist_success: 'Testiskenaarion S3-tallennus poistettu',
                persist_tooltip:
                    'Tallenna S3:een (palautuu yöpäivityksen jälkeen)',
                unpersist_tooltip: 'Tallennettu S3:een — klikkaa poistaaksesi',
                steps: {
                    basics: 'Perustiedot',
                    school_materials: 'Koulu, ryhmä ja materiaalit',
                    class: 'Ryhmä',
                    users: 'Käyttäjät',
                    options: 'Asetukset',
                    review: 'Yhteenveto',
                },
                fields: {
                    name: 'Nimi',
                    description: 'Kuvaus',
                    school: 'Koulu',
                    materials: 'Materiaalit',
                    class_name: 'Ryhmän nimi',
                    class_name_help:
                        'Tyhjäksi jättäminen käyttää skenaarion nimeä',
                    class_code: 'Ryhmän koodi',
                    class_code_help:
                        'Tyhjäksi jättäminen generoi automaattisen koodin',
                    class_highschool: 'Lukio',
                    add_learners_to_groups:
                        'Liitä oppilaat ja opiskelijat ryhmään',
                    add_learners_to_groups_help:
                        'Kun valinta ei ole päällä, oppilaat ja opiskelijat liitetään kouluun mutta ei testiryhmään.',
                    assign_licenses: 'Jaa lisenssit automaattisesti',
                    assign_licenses_help:
                        'Jos valittu, oppilaat ja opiskelijat saavat lisenssit materiaaleihin heti luonnissa',
                    accept_terms: 'Hyväksy käyttöehdot automaattisesti',
                    accept_terms_help:
                        'Jos valittu, testikäyttäjien ei tarvitse hyväksyä käyttöehtoja ensimmäisellä kirjautumiskerralla',
                    skip_remember_me: 'Ohita "Pysy kirjautuneena" -dialogi',
                    skip_remember_me_help:
                        'Jos valittu, testikäyttäjiltä ei kysytä "Pysy kirjautuneena" ensimmäisellä kirjautumiskerralla',
                    class_size: 'Ryhmäkoko',
                    class_size_help:
                        'Jos asetettu, oppilaat ja opiskelijat jaetaan useaan ryhmään (0 = yksi ryhmä)',
                    persist_to_s3: 'Tallenna S3:een luonnin jälkeen',
                    persist_to_s3_help:
                        'Jos valittu, testiskenaario tallennetaan automaattisesti S3:een ja palautuu yöpäivityksen jälkeen',
                    teacher_count: 'Opettajien määrä',
                    pupil_count: 'Oppilaiden määrä',
                    student_count: 'Opiskelijoiden määrä',
                    firstname_prefix: 'Etunimen alkuosa',
                    lastname: 'Sukunimi',
                    email_domain: 'Sähköpostin verkkotunnus',
                    password: 'Salasana',
                    keycode_prefix: 'Avainkoodin alkuosa',
                    mpass_profile: 'Luo käyttäjät MPASS-profiililla',
                    mpass_profile_help:
                        'Lisää rooliin sopivat MPASS-kirjautumistiedot generoidulla OID:llä. Testikoulun koulukoodia käytetään sellaisenaan.',
                    count: 'Lukumäärä',
                    created: 'Luotu',
                    group_name: 'Ryhmä',
                    school_name: 'Koulu',
                },
                detail: {
                    open_group: 'Avaa ryhmä hallinnassa',
                    multiple_groups: 'ryhmää',
                    persisted:
                        'Tallennettu S3:een — palautuu automaattisesti yöpäivityksen jälkeen',
                    not_persisted:
                        'Ei tallennettu S3:een — häviää yöpäivityksessä',
                    material_name: 'Materiaali',
                    material_subject: 'Aine',
                    material_series: 'Sarja',
                },
                sections: {
                    teachers: 'Opettajat',
                    pupils: 'Oppilaat',
                    students: 'Opiskelijat',
                },
                result: {
                    title: 'Testiskenaario luotu',
                    teachers: 'Opettajat',
                    pupils: 'Oppilaat',
                    students: 'Opiskelijat',
                    username: 'Käyttäjätunnus',
                    keycode: 'Avainkoodi',
                    group: 'Testiryhmä',
                },
            },
            error: 'Virhe ladattaessa tietoja',
            ecs: {
                title: 'ECS-palvelut',
                no_services: 'Ei palveluita',
                fields: {
                    serviceName: 'Palvelu',
                    status: 'Tila',
                    running: 'Käynnissä',
                    desired: 'Tavoite',
                    pending: 'Odottaa',
                    taskDefinition: 'Task Definition',
                    lastEvent: 'Viimeisin tapahtuma',
                },
            },
            rds: {
                title: 'RDS/Aurora-klusterit',
                no_clusters: 'Ei klustereita',
                fields: {
                    cluster: 'Klusteri',
                    status: 'Tila',
                    engine: 'Moottori',
                    endpoint: 'Endpoint (writer)',
                    readerEndpoint: 'Endpoint (reader)',
                    instances: 'Instanssit',
                },
            },
            rds_metrics: {
                title: 'RDS suorituskyky',
                no_cluster: 'Ei klustereita saatavilla',
                charts: {
                    cpu: 'CPU-käyttöaste (%)',
                    connections: 'Yhteydet',
                    readLatency: 'Lukuviive',
                    writeLatency: 'Kirjoitusviive',
                    readIOPS: 'Luku-IOPS',
                    writeIOPS: 'Kirjoitus-IOPS',
                    freeableMemory: 'Vapaa muisti',
                    networkReceive: 'Verkkoliikenne (sisään)',
                    networkTransmit: 'Verkkoliikenne (ulos)',
                },
            },
        },
        pos: {
            search: 'Etsi',
            configuration: 'Asetukset',
            language: 'Kieli',
            theme: {
                name: 'Theme',
                light: 'Light',
                dark: 'Dark',
            },
            filter: 'Filtered by',
            dashboard: {
                welcome: {
                    title: 'Teretulemast uuteen aspa-liittymään.',
                    subtitle: 'Tämä on uusi aspa-liittymä.',
                },
            },
        },
        resources: {
            user: {
                name: 'Ylläpitäjä |||| Ylläpitäjät |||| Kaikki ylläpitäjät',
                fields: {
                    // group: 'Ryhmä',
                    // groups: 'Ryhmät',
                    last_login: 'Kirjautunut',
                    registered: 'Rekisteröitynyt',
                    name: 'Nimi',
                    username: 'Tunnus',
                    status: 'Tila',
                    password: 'Salasana',
                    public: {
                        firstname: 'Etunimi',
                        middlename: 'Toinen nimi',
                        lastname: 'Sukunimi',
                        description: 'Kuvaus',
                        login_not_allowed: 'Estä kirjautuminen',
                        validfrom: 'Alkaa',
                        validto: 'Päättyy',
                        profile_locked: 'Tunnus lukittu',
                        profile_locked_message: 'Lähetä avaus viesti',
                        profile_locked_description:
                            'Jos avausviestiä ei lähetetä. Käyttäjä voi tilata avausviestin itse yrittäessään kirjautua palveluun.',
                    },
                    author: {
                        creator: 'Luoja',
                        created: 'Luotu',
                        modifier: 'Muokkaaja',
                        modified: 'Muokattu',
                    },
                    group: {
                        name: 'Nimi',
                        valid: 'Tunnuksen voimassaoloaika',
                        valid_desc:
                            'Jätä kentät tyhjiksi, jos et halua asettaa voimassaoloaikaa.',
                        ofduty: 'Vapaalla',
                        isadmin: 'Ylläpitäjä',
                        role: 'Rooli',
                        subrole: 'Opetusaineet',
                        status: 'Tila',
                        joined: 'Liittynyt',
                        no_classes: 'Ei luokkia',
                        show_archived: 'Näytä arkistoidut/poistetut',
                        archived: 'Arkistoitu',
                        deleted: 'Poistettu',
                        classes_count: 'Ryhmät',
                        active_classes_count: 'Aktiiviset ryhmät',
                        archived_or_deleted_classes_count:
                            'Arkistoidut/poistetut ryhmät',
                    },
                    applicationToAdd: 'Palvelu',
                    application: {
                        name: 'Palvelu',
                        isadmin: 'Ylläpitäjä',
                        role: 'Rooli',
                        envs: 'Ympäristöt',
                        status: 'Tila',
                    },
                },
                filters: {
                    status: 'Tila',
                    status_close: 'Tila',
                    schools: 'Oppilaitos',
                    'schools.search': 'Hae oppilaitosta',
                    schools_close: 'Oppilaitos',
                    invitation_delivery: 'Kutsun toimitus',
                },
                tabs: {
                    profile: 'Perustiedot',
                    application: 'Palvelut',
                    logs: 'Tapahtumaloki',
                },
                status: {
                    0: 'aktiivinen',
                    1: 'Poistettu',
                    2: 'Odottaa vahvistusta',
                    3: 'Rekisteröitymätön',
                    10: 'Mahdollinen tupla',
                },
                invitation: {
                    badge: 'Kutsu',
                    title: 'Hallinnoi kutsua',
                    pending: 'Kutsu odottaa',
                    none: 'Ei odottavia kutsuja',
                    expired: 'vanhentunut',
                    delivery: {
                        label: 'Toimitus',
                        delivered: 'Kutsu toimitettu',
                        failed: 'Kutsun toimitus epäonnistui',
                        pending: 'Kutsu lähetetty, odottaa vahvistusta',
                        unknown: 'Toimitustila ei tiedossa',
                        resend_exhausted:
                            'Automaattiyritykset käytetty (vaatii selvitystä)',
                        show_events: 'Näytä Mailgun-tapahtumat',
                        error_category: 'Syy',
                        error_raw: 'Tekninen virhe',
                        errors: {
                            bad_domain:
                                'Sähköpostiosoitteen verkkotunnusta ei löydy – osoitteessa on todennäköisesti kirjoitusvirhe.',
                            access_denied:
                                'Vastaanottajan palvelin hylkäsi viestin käyttöoikeussyistä (esim. organisaation asetukset estävät ulkopuoliset viestit).',
                            no_mailbox:
                                'Vastaanottajan sähköpostiosoitetta ei ole olemassa.',
                            mailbox_full:
                                'Vastaanottajan postilaatikko on täynnä.',
                            mail_loop:
                                'Vastaanottajan postin edelleenlähetys on jumissa silmukassa (mail loop), eikä viesti mene perille.',
                            blocked:
                                'Viesti estettiin vastaanottajan palvelimella.',
                            other: 'Muu toimitusvirhe (katso tekninen viesti).',
                        },
                    },
                    dialog: {
                        title: 'Hallinnoi käyttäjän kutsua',
                        section_status: 'Kutsun tila',
                        manual_sends: 'Manuaaliset uudelleenlähetykset',
                        manual_send_source_admin: 'Otavan asiakaspalvelu',
                        manual_send_source_nova: 'Koulun ylläpitäjä',
                        section_school: 'Oppilaitos',
                        section_link: 'Aktivointilinkki',
                        content:
                            'Lähetä kutsu käyttäjälle %{name} (%{username}) tähän kouluun',
                        confirm: 'Lähetä kutsu',
                        cancel: 'Peruuta',
                        language: 'Kieli',
                        sent_count:
                            'Kutsu on lähetetty %{count} kertaa aikaisemmin',
                        not_sent: 'Kutsua ei ole vielä lähetetty',
                        first_sent: 'Ensimmäinen kutsu lähetetty',
                        last_sent: 'Viimeisin kutsu lähetetty',
                        last_auto_resend:
                            'Viimeisin automaattinen uudelleenlähetys (%{count} krt)',
                        expired: 'Kutsu on vanhentunut — lähetä uusi kutsu.',
                        auto_resend_label: 'Automaattinen uudelleenlähetys',
                        auto_resend_on: 'käytössä',
                        auto_resend_off_disabled: 'ei käytössä',
                        auto_resend_off_not_pending: 'ei odottava kutsu',
                        auto_resend_off_exhausted:
                            'uusintojen enimmäismäärä saavutettu',
                        auto_resend_off_expired: 'kutsu liian vanha (TTL)',
                        auto_resend_off_delivered: 'kutsu jo toimitettu',
                        auto_resend_off_permanent_error:
                            'osoite/domain pysyvästi virheellinen',
                        auto_resend_next:
                            'Seuraava uudelleenlähetys aikaisintaan',
                        auto_resend_due: 'seuraavalla ajolla',
                        show_activation_link: 'Näytä aktivointilinkki',
                        activation_link_help:
                            'Opettajan henkilökohtainen aktivointilinkki, jolla hän vahvistaa sähköpostiosoitteensa ja pääsee kirjautumaan Novaan. Käytä tätä, jos kutsusähköposti ei mennyt perille: toimita linkki opettajalle luotettavaa kanavaa pitkin (esim. koulun oma sähköposti tai puhelin). Linkki on voimassa 24 tuntia kutsun lähetyksestä — jos se on vanhentunut, lähetä uusi kutsu.',
                    },
                    bulk_resend: 'Lähetä kutsu uudelleen',
                    bulk_confirm_title: 'Lähetä kutsu uudelleen',
                    bulk_confirm_content:
                        'Lähetä kutsu uudelleen %{count} valitulle opettajalle?',
                    bulk_result:
                        'Lähetetty %{sent} · ei odottavaa kutsua %{no_pending} · ei validia sähköpostia %{invalid_email} · pysyvä bounce %{permanent_bounce} · virhe %{errors}',
                    bulk_error: 'Kutsujen massalähetys epäonnistui',
                },
                session: {
                    remaining: 'Istuntoa jäljellä',
                    active_sessions: 'aktiivista istuntoa',
                    longest: 'pisin',
                    confirm_remove:
                        'Haluatko varmasti poistaa istunnon ja kirjata käyttäjän ulos?',
                    confirm_remove_all:
                        'Haluatko varmasti poistaa kaikki %{count} istuntoa ja kirjata käyttäjän ulos kaikista laitteista?',
                },
                stale: {
                    title: 'Tietojen tila',
                    up_to_date: 'Tiedot ajan tasalla',
                    stale: 'Tiedot vanhentuneet',
                    last_checked: 'Viimeksi tarkistettu',
                    force_toggle: 'Pakota tarkistus / poista pakotus',
                    natural_hint:
                        'Tiedot ovat vanhentuneet myös ilman pakotusta (viimeisin tarkistus liian kaukana) - pakotuksen poistaminen ei yksinään muuta tilaa ajan tasalle.',
                    forced: 'Käyttäjä pakotettu tarkistamaan tietonsa',
                    cleared: 'Pakotus poistettu',
                    bulk_force: 'Pakota tarkistus (valitut)',
                    bulk_confirm_title: 'Pakota tietojen tarkistus',
                    bulk_confirm_content:
                        'Merkitään %{count} valittua käyttäjää vanhentuneeksi - he joutuvat tarkistamaan tietonsa seuraavalla kirjautumisella?',
                    bulk_result:
                        'Merkitty vanhentuneeksi: %{updated}/%{requested}',
                    bulk_error: 'Massapakotus epäonnistui',
                },
                help: {
                    modifyuserapp: 'Muokkaa käyttäjän palvelu asetuksia.',
                },
                actions: {
                    approve: 'Vahvista',
                    changepassword: 'Vaihda salasana',
                    reapprove: 'Uusi vahvistuspyyntö',
                    remove_mpass: 'Poista MPASS-liitos',
                    remove_session: 'Poista istunto ja kirjaa käyttäjä ulos.',
                    open_crm: 'Avaa opettajan tiedot (CRM)',
                    debug_mpass_original:
                        'Debug: MPASS tunnistautuminen alkuperäinen',
                    debug_mpass_new: 'Debug: MPASS tunnistautuminen uusi',
                    debug_mpass_menu: 'Debug: MPASS-testit',
                    debug_mpass_wrong_app:
                        'Debug: Testaa ohjautuminen väärästä sovelluksesta samalla MPASS-testidatalla',
                    debug_mpass_json: 'Debug: MPASS-data',
                    mpass_profile: 'MPASS-perustiedot',
                    debug_mpass_masked: 'Maskattu testi (localhost)',
                    debug_mpass_masked_help: 'Nimet, henkilötunnisteet ja luokkanimet on korvattu testiarvoilla. Koulu-, organisaatio- ja roolitiedot säilyvät oikeina, joten data ei ole varmasti anonyymi. Tarkista testiympäristö: kirjautuminen voi luoda tilejä ja käyttää siihen määritettyjä ulkoisia integraatioita.',
                    mpass_name: 'MPASSista saatu nimi',
                    mpass_nickname: 'MPASSista saatu kutsumanimi (nickname)',
                    mpass_name_changed: 'MPASS-tiedoissa on nimenmuutosmerkintä. Aiempi nimi ja muutosaika: %{previous}',
                    mpass_schools: 'Oppilaitokset',
                    mpass_roles: 'Roolit',
                    mpass_classes: 'Luokat / ryhmät',
                    mpass_last_login: 'Viimeisin tallennettu MPASS-kirjautuminen',
                    debug_mpass_dialog_title: 'MPASS-testitunnistautumisen tiedot',
                    debug_mpass_json_help:
                        'Tässä on tunnistautumiseen lähetettävä MPASS-profiili. Voit muokata JSONia, myös virheellisten tietojen testaamiseksi. Profiilia ei tallenneta käyttäjälle.',
                    debug_mpass_start: 'Aloita MPASS-testitunnistautuminen',
                    debug_mpass_cancel: 'Peruuta',
                    new: {
                        title: 'Uusi käyttäjä',
                    },
                    reset_password: {
                        title: 'Salasanan resetointi linkki',
                        help_text:
                            'Salasanan palautuslinkki on kertakäyttöinen ja vanhenee käytön jälkeen. Huom. Uuden palautuslinkin tilaaminen mitätöi aina kaikki aiemmin luodut, käyttämättömät linkit.',
                        button_label: 'Salasanan resetointi linkki',
                        description: `Hei!

Tässä on linkki salasanasi nollaamiseen: 
%{link}. 
Kopioi linkki ja avaa se selaimessa. Pääset sitten luomaan uuden salasanan.

Ystävällisin terveisin
Otava Oppiminen
`,
                    },
                },
            },
            teacher: {
                name: 'Opettaja |||| Opettajat',
                actions: {
                    back: 'Takaisin koulutietoihin',
                    approve: {
                        button_title: 'Vahvista',
                        dialog: {
                            title: 'Vahvista %{mode}',
                            content:
                                'Olet vahvistamassa käyttäjää %{name} (%{username})',
                            schools: 'Oppilaitokset, joihin käyttäjä liitetään',
                            sendmail: 'Lähetä vahvistuksesta sähköposti',
                            cancel: 'Peruuta',
                            confirm: 'Vahvista',
                            language: 'Kieli',
                        },
                        success: 'Toiminto onnistui',
                        error: 'Vahvistus epäonnistui',
                    },
                    remove: {
                        button_title: 'Poista',
                        dialog: {
                            title: 'Vahvista %{mode} poisto',
                            content:
                                'Olet vahvistamassa käyttäjää %{name} (%{username})',
                            schools:
                                'Oppilaitokset, joista käyttäjä poistetaan',
                            remove_groups:
                                'Poista käyttäjä myös poistettavien oppilaitosten ryhmistä',
                            remove_user:
                                'Merkitse myös käyttäjä (%{name}) poistetuksi',
                            cancel: 'Peruuta',
                            confirm: 'Vahvista',
                            language: 'Kieli',
                        },
                        success: 'Toiminto onnistui',
                        error: 'Vahvistus epäonnistui',
                    },
                    unremove: {
                        button_title: 'Palauta',
                        success: 'Toiminto onnistui',
                        error: 'Palautus epäonnistui',
                    },
                    add_school: 'Lisää oppilaitos',
                    export_duplicates: 'Vie tuplat Exceliin',
                    new: {
                        title: 'Uusi opettaja',
                        sendmail: 'Viesti opettajalle',
                        lang: 'Kieli',
                        application: 'Palvelu',
                        messagepreview: 'Viestin esikatselu',
                        nomailtemplate:
                            'Palvelulle ei ole toteutettu toimintoa. Viestiä ei voida lähettää.',
                        mailtemplateinactive:
                            'Viestipohja ei ole aktiivinen. Viestiä ei voida lähettää.',
                    },
                    changepassword: 'Vaihda salasana',
                    reapprove: 'Uusi vahvistuspyyntö',
                    gdpr: {
                        button_title: 'GDPR Poisto',
                        success: 'GDPR Poisto onnistui',
                        error: 'GDPR Poisto epäonnistui',
                        dialog: {
                            title: 'GDPR Poisto',
                            content:
                                'Olet poistamassa opettajaa %{name} (%{email}). Toimintoa ei voi peruuttaa.',
                            describe_service:
                                'Poistopyyntö %{service} tunnisteella: %{id}',
                            extra_content:
                                'HUOM ! Ota GDPR Poistopyynnöt talteen ennen poistoa.',
                            confirm: 'Poista',
                            cancel: 'Peruuta',
                        },
                    },
                },
                fields: {
                    last_login: 'Kirjautunut',
                    registered: 'Rekisteröitynyt',
                    joined: 'Liittynyt',
                    modified: 'Muokattu',
                    name: 'Nimi',
                    username: 'Työsähköpostiosoite',
                    username_column: 'Tunnus',
                    status: 'Tila',
                    password: 'Salasana',
                    validfrom: 'Voimassaolo alkaa',
                    validto: 'Voimassaolo päättyy',
                    public: {
                        firstname: 'Etunimi',
                        middlename: 'Toinen nimi',
                        lastname: 'Sukunimi',
                        description: 'Kuvaus',
                        learning_environment_1: 'Google Classroom',
                        learning_environment_2: 'Office 365',
                        learning_environment_3: 'Kampus',
                        learning_environment_4: 'Moodle',
                        learning_environment_5: 'Itslearning',
                        learning_environment_6: 'Peda.net',
                        learning_environment_free: 'Joku muu, mikä?',
                        login_not_allowed: 'Estä kirjautuminen',
                        validfrom: 'Alkaa',
                        validto: 'Päättyy',
                        profile_locked: 'Tunnus lukittu',
                        'infra:merged': 'Yhdistetty',
                    },
                    author: {
                        creator: 'Luoja',
                        created: 'Luotu',
                        modifier: 'Muokkaaja',
                        modified: 'Muokattu',
                    },
                    schools: 'Oppilaitokset',
                    groups: 'Ryhmät',
                    options: 'Asetukset',
                    school: {
                        title: 'Oppilaitos',
                        registered: 'Liitynyt',
                        settings: 'Asetukset',
                        group: 'Ryhmä',
                    },
                    group: {
                        valid: 'Tunnuksen voimassaoloaika',
                        valid_desc:
                            'Jätä kentät tyhjiksi, jos et halua asettaa voimassaoloaikaa.',
                        ofduty: 'Vapaalla',
                        isadmin: 'Oikeudet päivittää koulun tietoja',
                        role: 'Rooli',
                        subrole: 'Opetusaineet',
                        validfrom: 'Alkaa',
                        validto: 'Päättyy',
                    },
                    role: {
                        guid: 'Rooli',
                        subjects: 'Opetusaineet',
                    },
                    application: 'Palvelu',
                    services: 'Lähteet',
                },
                tabs: {
                    profile: 'Perustiedot',
                    schools_and_groups: 'Koulut ja ryhmät',
                    materials: 'Käytössä',
                    merge: 'Yhdistäminen',
                    schools: 'Oppilaitokset',
                    classes: 'Luokat',
                    role: 'Rooli',
                    subject: 'Opetusaineet',
                    isadmin: 'Ylläpitäjä',
                    ofduty: 'Vapaalla',
                    logs: 'Loki',
                    status: 'Tila',
                    application: 'Palvelut',
                    crm: 'CRM',
                },
                cache: {
                    label: 'Valkey-muisti',
                    cached: 'Välimuistissa',
                    not_cached: 'Ei välimuistissa',
                    ttl_remaining: 'Aikaa jäljellä',
                    expires_at: 'Vanhenee',
                    refresh: 'Tarkista välimuistin tila',
                    view_data: 'Katso välimuistissa oleva data',
                    flush: 'Tyhjennä välimuisti',
                    flush_confirm:
                        'Tyhjennetäänkö opettajan fulldata-välimuistiavain %{key}? Seuraava kumppanirajapinnan kutsu rakentaa sen uudelleen.',
                    flushed: 'Välimuisti tyhjennetty',
                    flush_error: 'Välimuistin tyhjennys epäonnistui',
                },
                page: {
                    delete: 'Poista opettaja',
                    create: 'Lisää opettaja',
                    addSchool: 'Lisää oppilaitos',
                    addApp: 'Lisää palvelu',
                    changepassword: {
                        title: 'Salasanan vaihtaminen',
                        oldpassword: 'Vanha salasana',
                        newpassword: 'Syötä uusi salsana',
                        responses: {
                            401: 'Vanha salasana virheellinen',
                            404: 'Virheellinen käyttäjä',
                            500: 'Salasanan vaihto epäonnistui, yritä hetken päästä uudelleen.',
                            200: 'Salasana on vaihdettu',
                        },
                    },
                },
                status: {
                    0: 'Aktiivinen |||| Aktiivisia',
                    1: 'Poistettu |||| Poistettuja',
                    2: 'Odottaa vahvistusta |||| Odottaa vahvistusta',
                    3: 'Rekisteröitymätön |||| Rekisteröimättömiä',
                },
                help: {
                    createform:
                        'Luo uusi opettaja ja liitä hänet oppilaitokseen. Tunnus on voimassa toistaiseksi, mikäli voimassaoloa ei määritetä.',
                    modifyschoolform: 'Muokkaa opettajan koulutietoja.',
                },
                crm: {
                    no_crm_guid: 'CRM GUID ei löydy opettajan tiedoista',
                    no_teacher_guid: 'Opettajan GUID puuttuu',
                    loading: 'Ladataan CRM-tietoja...',
                    error: 'Virhe CRM-tietojen latauksessa',
                    contact_info: 'Yhteystiedot CRM',
                    contact_id: 'Kontaktin ID',
                    firstname: 'Etunimi',
                    lastname: 'Sukunimi',
                    email: 'Sähköpostiosoite',
                    phone: 'Puhelinnumero',
                    job_title: 'Tehtävänimike',
                    no_data: 'Ei CRM-tietoja saatavilla',
                    no_schools: 'Ei kouluja',
                    not_available: 'Ei saatavilla',
                    raw_data: 'Raakadata (kehittäjille)',
                    fields_with_data: 'Kentät joissa on dataa',
                    fields: 'kenttää',
                    fields_filtered: 'suodatettu pois',
                    yes: 'Kyllä',
                    no: 'Ei',
                    'Ifa Isoppimisenpalvelutcustomer': 'OOP asiakas',
                    'Ifa Isfinnlecturacustomer': 'Finn Lectura asiakas',
                    accounts_title: 'Oppilaitokset CRM:stä',
                    school_relationships_title:
                        'Koulut ja oppilaitokset, joissa toimii',
                    unnamed_account: 'Nimetön oppilaitos',
                    account_not_found: 'Koulun tietoja ei löytynyt',
                    relationship_info: 'Opetussuhteen tiedot',
                    school_info: 'Koulun tiedot',
                    on_vacation: 'Lomalla',
                    table_headers: {
                        school_name: 'Oppilaitos',
                        role: 'Rooli',
                        subjects: 'Opetusaineet',
                        status: 'Tila',
                    },
                    status: {
                        active: 'Aktiivinen',
                        inactive: 'Ei aktiivinen',
                    },
                    // Field translations
                    fieldLabels: {
                        contactid: 'Yhteystieto-ID',
                        firstname: 'Etunimi',
                        lastname: 'Sukunimi',
                        fullname: 'Koko nimi',
                        emailaddress1: 'Sähköposti',
                        telephone1: 'Puhelin',
                        mobilephone: 'Matkapuhelin',
                        jobtitle: 'Ammattinimike',
                        department: 'Osasto',
                        company: 'Yritys',
                        managername: 'Esimiehen nimi',
                        assistantname: 'Assistentin nimi',
                        assistantphone: 'Assistentin puhelin',
                        spousesname: 'Puolison nimi',
                        nickname: 'Lempinimi',
                        anniversary: 'Vuosipäivä',
                        address1_line1: 'Osoiterivi 1',
                        address1_line2: 'Osoiterivi 2',
                        address1_city: 'Kaupunki',
                        address1_stateorprovince: 'Lääni/Maakunta',
                        address1_postalcode: 'Postinumero',
                        address1_country: 'Maa',
                        createdon: 'Luotu',
                        modifiedon: 'Muokattu',
                        statecode: 'Tila',
                        statuscode: 'Statuskoodi',
                        ownerid: 'Omistaja ID',
                        // Marketing restriction fields
                        donotphone: 'Soittokielto',
                        donotemail: 'Suorasähköpostin lähetys kielto',
                        donotbulkemail: 'Joukkosähköpostin lähetys kielto',
                        ifa_isoppimisenpalvelutcustomer: 'OOP asiakas',
                        ifa_isfinnlecturacustomer: 'FL asiakas',
                    },
                    // Relationship (school-teacher) field translations
                    relationshipLabels: {
                        ifa_roletype: 'Rooli',
                        ifa_influencerroletype: 'Vaikuttajan rooli',
                        ifa_startdate: 'Alkamispäivä',
                        ifa_enddate: 'Päättymispäivä',
                        ifa_isonvacation: 'Lomalla',
                        subjects: 'Opetettavat aineet',
                    },
                    // Role type code mappings from CRM
                    roleTypes: {
                        '225080000': 'Esiopettaja',
                        '225080001': 'Luokanopettaja, 1-2',
                        '225080002': 'Luokanopettaja, 3-6',
                        '225080003': 'Erityisopettaja',
                        '225080004': 'Aineenopettaja',
                        '225080005': 'Koulusihteeri',
                        '225080006': 'Rehtori',
                        '225080007': 'Sijainen',
                        '225080008': 'Opetusharjoittelija',
                        '225080009': 'Resurssiopettaja',
                        '225080010': 'Koulunkäyntiavustaja',
                        '225080011': 'Opettaja',
                        '225080012': 'Hallintohenkilö',
                        '225080013': 'Koulunkäynninohjaaja',
                    },
                    // State code mappings from CRM
                    statecode: {
                        '0': 'Aktiivinen',
                        '1': 'Passivoitu',
                    },
                    // Account (school) field translations
                    accountLabels: {
                        accountid: 'Oppilaitoksen ID',
                        name: 'Oppilaitoksen nimi',
                        ifa_schoolid: 'Koulun ID',
                        ifa_schoolcode: 'Koulukoodi',
                        ifa_schooltype: 'Koulun tyyppi',
                        emailaddress1: 'Sähköposti',
                        telephone1: 'Puhelin',
                        telephone2: 'Puhelin 2',
                        telephone3: 'Puhelin 3',
                        address: 'Osoite',
                        address1_line1: 'Osoiterivi 1',
                        address1_line2: 'Osoiterivi 2',
                        address1_city: 'Kaupunki',
                        address1_postalcode: 'Postinumero',
                        ifa_principalname: 'Rehtorin nimi',
                        ifa_principalemail: 'Rehtorin sähköposti',
                        ifa_principalphone: 'Rehtorin puhelin',
                        ifa_principalmobile: 'Rehtorin matkapuhelin',
                        ifa_numberofteachers: 'Opettajien määrä',
                        ifa_numberofstudents: 'Oppilaiden määrä',
                        ifa_isoppimisenpalvelutcustomer:
                            'Onko oppimisen palveluiden asiakas',
                        ifa_isfinnlecturacustomer: 'Onko finnlectura asiakas',
                        ifa_minclass: 'Alin luokka-aste',
                        ifa_maxclass: 'Ylin luokka-aste',
                        ifa_school: 'Koulu',
                        ifa_isswedish: 'Ruotsinkielinen',
                        ifa_password: 'Salasana',
                        modifiedon: 'Muokattu',
                        createdon: 'Luotu',
                        statecode: 'Tilakoodi',
                    },
                },
                empty_header: 'Ei opettajia',
            },
            student: {
                name: 'Opiskelija |||| Opiskelijat',
                actions: {
                    back: 'Takaisin koulutietoihin',
                    changepassword: 'Vaihda salasana',
                    reapprove: 'Uusi vahvistuspyyntö',
                    gdpr: {
                        button_title: 'GDPR Poisto',
                        success: 'GDPR Poisto onnistui',
                        error: 'GDPR Poisto epäonnistui',
                        dialog: {
                            title: 'GDPR Poisto',
                            content:
                                'Olet poistamassa opiskelijaa %{name} (%{email}). Toimintoa ei voi peruuttaa.',
                            describe_service:
                                'Poistopyyntö %{service} tunnisteella: %{id}',
                            extra_content:
                                'HUOM ! Ota GDPR Poistopyynnöt talteen ennen poistoa.',
                            confirm: 'Poista',
                            cancel: 'Peruuta',
                        },
                    },
                    new: {
                        title: 'Uusi opiskelija',
                    },
                    export: {
                        10: 'Vie tuplat Exceliin',
                    },
                    approve: {
                        button_title: 'Vahvista',
                        dialog: {
                            title: 'Vahvista %{mode}',
                            content:
                                'Olet vahvistamassa käyttäjää %{name} (%{username})',
                            schools: 'Oppilaitokset, joihin käyttäjä liitetään',
                            sendmail: 'Lähetä vahvistuksesta sähköposti',
                            cancel: 'Peruuta',
                            confirm: 'Vahvista',
                            language: 'Kieli',
                        },
                        success: 'Toiminto onnistui',
                        error: 'Vahvistus epäonnistui',
                    },
                    remove: {
                        button_title: 'Poista',
                        dialog: {
                            title: 'Vahvista %{mode} poisto',
                            content:
                                'Olet vahvistamassa käyttäjää %{name} (%{username})',
                            schools:
                                'Oppilaitokset, joista käyttäjä poistetaan',
                            remove_groups:
                                'Poista käyttäjä myös poistettavien oppilaitosten ryhmistä',
                            remove_user:
                                'Merkitse myös käyttäjä (%{name}) poistetuksi',
                            cancel: 'Peruuta',
                            confirm: 'Vahvista',
                            language: 'Kieli',
                        },
                        success: 'Toiminto onnistui',
                        error: 'Vahvistus epäonnistui',
                    },
                },
                fields: {
                    last_login: 'Kirjautunut',
                    registered: 'Rekisteröitynyt',
                    joined: 'Liittynyt',
                    modified: 'Muokattu',
                    name: 'Nimi',
                    username: 'Kirjavälityksen tunnus',
                    status: 'Tila',
                    password: 'Salasana',
                    email: 'Sähköpostiosoite',
                    alt_email: 'Vaihtoehtoiset sähköpostiosoitteet',
                    materialcharge: {
                        title: 'Materiaalien maksullisuus',
                        no: 'Ei',
                        yes: 'Kyllä',
                        unknown: 'Ei tiedossa',
                    },
                    school: {
                        title: 'Oppilaitos',
                        registered: 'Liitynyt',
                    },
                    public: {
                        email: 'Sähköpostiosoite',
                        emails: 'Vaihtoehtoiset sähköpostiosoitteet',
                        firstname: 'Etunimi',
                        middlename: 'Toinen nimi',
                        lastname: 'Sukunimi',
                        description: 'Kuvaus',
                        login_not_allowed: 'Estä kirjautuminen',
                        validfrom: 'Alkaa',
                        validto: 'Päättyy',
                        profile_locked: 'Tunnus lukittu',
                        'infra:merged': 'Yhdistetty',
                    },
                    author: {
                        creator: 'Luoja',
                        created: 'Luotu',
                        modifier: 'Muokkaaja',
                        modified: 'Muokattu',
                    },
                    group: {
                        valid: 'Tunnuksen voimassaoloaika',
                        valid_desc:
                            'Jätä kentät tyhjiksi, jos et halua asettaa voimassaoloaikaa.',
                        validfrom: 'Alkaa',
                        validto: 'Päättyy',
                        ofduty: 'Vapaalla',
                        isadmin: 'Oikeudet päivittää koulun tietoja',
                        role: 'Rooli',
                        subrole: 'Opetusaineet',
                    },
                    application: 'Palvelu',
                    services: 'Lähteet',
                },
                tabs: {
                    profile: 'Perustiedot',
                    schools_and_groups: 'Koulut ja ryhmät',
                    materials: 'Käytössä',
                    merge: 'Yhdistäminen',
                    schools: 'Oppilaitokset',
                    classes: 'Luokat',
                    role: 'Rooli',
                    subject: 'Opetusaineet',
                    isadmin: 'Ylläpitäjä',
                    ofduty: 'Vapaalla',
                    logs: 'Loki',
                    status: 'Tila',
                    application: 'Palvelut',
                },
                page: {
                    delete: 'Poista opettaja',
                    create: 'Lisää opettaja',
                    addSchool: 'Lisää oppilaitos',
                    addApp: 'Lisää palvelu',
                    changepassword: {
                        title: 'Salasanan vaihtaminen',
                        oldpassword: 'Vanha salasana',
                        newpassword: 'Syötä uusi salsana',
                        responses: {
                            401: 'Vanha salasana virheellinen',
                            404: 'Virheellinen käyttäjä',
                            500: 'Salasanan vaihto epäonnistui, yritä hetken päästä uudelleen.',
                            200: 'Salasana on vaihdettu',
                        },
                    },
                },
                status: {
                    0: 'Aktiivinen |||| Aktiivisia',
                    1: 'Poistettu |||| Poistettuja',
                    2: 'Odottaa vahvistusta |||| Odottaa vahvistusta',
                    3: 'Rekisteröitymätön |||| Rekisteröimättömiä',
                },
                help: {
                    createform:
                        'Luo uusi opettaja ja liitä hänet oppilaitokseen. Tunnus on voimassa toistaiseksi, mikäli voimassaoloa ei määritetä.',
                    modifyschoolform: 'Muokkaa opettajan koulutietoja.',
                },
                empty_header: 'Ei opiskelijoita',
            },
            pupil: {
                name: 'Oppilas |||| Oppilaat',
                codes: [
                    'aalto',
                    'aamu',
                    'aarre',
                    'ahven',
                    'aine',
                    'aisti',
                    'aito',
                    'akseli',
                    'alasin',
                    'alku',
                    'alpakka',
                    'askel',
                    'atlantti',
                    'atomi',
                    'aurinko',
                    'avain',
                    'elo',
                    'hanko',
                    'happi',
                    'harakka',
                    'harju',
                    'hattu',
                    'hauki',
                    'haukka',
                    'heitto',
                    'helmi',
                    'herhiläinen',
                    'hiekka',
                    'hiili',
                    'hiiri',
                    'hiutale',
                    'hopea',
                    'huhta',
                    'huhti',
                    'huippu',
                    'hukka',
                    'hylly',
                    'hymy',
                    'höyhen',
                    'ikkuna',
                    'ilo',
                    'ilta',
                    'ilves',
                    'into',
                    'jalava',
                    'jalo',
                    'joki',
                    'jono',
                    'jousi',
                    'juhla',
                    'juuri',
                    'jälki',
                    'jälki',
                    'kaarre',
                    'kaiku',
                    'kakku',
                    'kala',
                    'kallio',
                    'kameli',
                    'kani',
                    'kaniini',
                    'kansi',
                    'karhu',
                    'kartta',
                    'karviainen',
                    'kasse',
                    'kasvi',
                    'kaura',
                    'kauris',
                    'keino',
                    'keinu',
                    'kello',
                    'keltainen',
                    'kerho',
                    'kerros',
                    'kesä',
                    'kettu',
                    'kevät',
                    'kielo',
                    'kierros',
                    'kierto',
                    'kimalainen',
                    'kipinä',
                    'kirahvi',
                    'kirja',
                    'kirjain',
                    'kirjasto',
                    'kirsu',
                    'kissa',
                    'kivi',
                    'koira',
                    'koivu',
                    'koju',
                    'kontio',
                    'korento',
                    'kori',
                    'koti',
                    'koulu',
                    'kuikka',
                    'kuitu',
                    'kukka',
                    'kulku',
                    'kulma',
                    'kulta',
                    'kuohu',
                    'kupari',
                    'kurki',
                    'kurre',
                    'kuu',
                    'kuusi',
                    'kuva',
                    'kyyhky',
                    'käpy',
                    'käpälä',
                    'lahja',
                    'lahti',
                    'laine',
                    'laituri',
                    'laiva',
                    'lammas',
                    'lasi',
                    'lasku',
                    'latva',
                    'laulu',
                    'laulu',
                    'lehti',
                    'lehto',
                    'leijona',
                    'leikki',
                    'leipä',
                    'lento',
                    'leopardi',
                    'leppä',
                    'liekki',
                    'liina',
                    'lintu',
                    'lippu',
                    'lohi',
                    'loiste',
                    'luku',
                    'lumi',
                    'lumo',
                    'luokka',
                    'luonto',
                    'maa',
                    'maailma',
                    'maasto',
                    'maila',
                    'majakka',
                    'manner',
                    'mansikka',
                    'marmori',
                    'matka',
                    'mehiläinen',
                    'meri',
                    'metsä',
                    'miekkavalas',
                    'mustikka',
                    'muurahainen',
                    'myrsky',
                    'mäki',
                    'nappi',
                    'nauha',
                    'neptunus',
                    'niemi',
                    'niitty',
                    'numero',
                    'nummi',
                    'nuotio',
                    'oiva',
                    'oksa',
                    'olki',
                    'omena',
                    'onki',
                    'onni',
                    'opas',
                    'oppi',
                    'orava',
                    'otso',
                    'ovi',
                    'paiste',
                    'pala',
                    'pallo',
                    'paperi',
                    'pelikaani',
                    'perho',
                    'peura',
                    'pihlaja',
                    'pino',
                    'pinta',
                    'pisara',
                    'pluto',
                    'pohjanmeri',
                    'polku',
                    'portti',
                    'pronssi',
                    'puhe',
                    'puhuri',
                    'punainen',
                    'puomi',
                    'purje',
                    'puro',
                    'puu',
                    'pyy',
                    'päivä',
                    'raikas',
                    'raita',
                    'raita',
                    'ranta',
                    'rastas',
                    'rata',
                    'ratas',
                    'rauta',
                    'reitti',
                    'repo',
                    'reppu',
                    'retki',
                    'riemu',
                    'ruis',
                    'rusko',
                    'ruusu',
                    'sade',
                    'sakset',
                    'salmi',
                    'sammal',
                    'sarja',
                    'sato',
                    'sauna',
                    'savu',
                    'siipi',
                    'silta',
                    'simpukka',
                    'sininen',
                    'sisko',
                    'sivu',
                    'sointu',
                    'soitin',
                    'solki',
                    'sudenkorento',
                    'sulka',
                    'sumu',
                    'syksy',
                    'syksy',
                    'syys',
                    'sävel',
                    'taika',
                    'taimen',
                    'taimi',
                    'taito',
                    'taituri',
                    'talo',
                    'talvi',
                    'tammi',
                    'tanner',
                    'tarha',
                    'tasku',
                    'tassu',
                    'telkkä',
                    'tellus',
                    'tenho',
                    'teos',
                    'tiainen',
                    'tie',
                    'tieto',
                    'tiikeri',
                    'tiira',
                    'tikka',
                    'tikkari',
                    'tikli',
                    'tilke',
                    'timantti',
                    'tina',
                    'torni',
                    'touko',
                    'tovi',
                    'tuli',
                    'tunti',
                    'tunturi',
                    'tuohi',
                    'tuokio',
                    'tuoli',
                    'tuomi',
                    'tuore',
                    'tupa',
                    'tuuli',
                    'tyvi',
                    'tähti',
                    'täky',
                    'uikku',
                    'ukko',
                    'ulappa',
                    'usva',
                    'vaaka',
                    'vadelma',
                    'vahti',
                    'valkoinen',
                    'valo',
                    'varpunen',
                    'vasta',
                    'vasu',
                    'vene',
                    'vene',
                    'veto',
                    'vety',
                    'vihreä',
                    'vihta',
                    'viima',
                    'viiri',
                    'vimma',
                    'violetti',
                    'virta',
                    'voima',
                    'vuori',
                    'vuoro',
                    'välke',
                ],
                actions: {
                    new: {
                        title: 'Uusi oppilas',
                    },
                    export: {
                        10: 'Vie tuplat Exceliin',
                    },
                    approve: {
                        button_title: 'Vahvista',
                        dialog: {
                            title: 'Vahvista %{mode}',
                            content:
                                'Olet vahvistamassa käyttäjää %{name} (%{username})',
                            schools: 'Oppilaitokset, joihin käyttäjä liitetään',
                            sendmail: 'Lähetä vahvistuksesta sähköposti',
                            cancel: 'Peruuta',
                            confirm: 'Vahvista',
                            language: 'Kieli',
                        },
                        success: 'Toiminto onnistui',
                        error: 'Vahvistus epäonnistui',
                    },
                    remove: {
                        button_title: 'Poista',
                        dialog: {
                            title: 'Vahvista %{mode} poisto',
                            content:
                                'Olet vahvistamassa käyttäjää %{name} (%{username})',
                            schools:
                                'Oppilaitokset, joista käyttäjä poistetaan',
                            remove_groups:
                                'Poista käyttäjä myös poistettavien oppilaitosten ryhmistä',
                            remove_user:
                                'Merkitse myös käyttäjä (%{name}) poistetuksi',
                            cancel: 'Peruuta',
                            confirm: 'Vahvista',
                            language: 'Kieli',
                        },
                        success: 'Toiminto onnistui',
                        error: 'Vahvistus epäonnistui',
                    },
                },
                fields: {
                    last_login: 'Kirjautunut',
                    registered: 'Rekisteröitynyt',
                    joined: 'Liittynyt',
                    modified: 'Muokattu',
                    name: 'Nimi',
                    username: 'Sähköposti',
                    license_status: 'Lisenssin tila',
                    licenses: 'Käytössä',
                    password: 'Salasana',
                    public: {
                        firstname: 'Etunimi',
                        middlename: 'Toinen nimi',
                        lastname: 'Sukunimi',
                        code: 'Avainkoodi',
                        login_not_allowed: 'Estä kirjautuminen',
                        validfrom: 'Alkaa',
                        validto: 'Päättyy',
                        profile_locked: 'Tunnus lukittu',
                    },
                    school: {
                        title: 'Oppilaitos',
                        registered: 'Liitynyt',
                    },
                    schools: 'Oppilaitokset',
                    groups: 'Ryhmät',
                    class: 'Luokka',
                    group_name: 'Luokka',
                    author: {
                        creator: 'Luoja',
                        created: 'Luotu',
                        modifier: 'Muokkaaja',
                        modified: 'Muokattu',
                    },
                    services: 'Lähteet',
                },
                tabs: {
                    profile: 'Perustiedot',
                    schools_and_groups: 'Koulut ja ryhmät',
                    materials: 'Käytössä',
                    merge: 'Yhdistäminen',
                    schools: 'Oppilaitokset',
                    classes: 'Luokat',
                    role: 'Rooli',
                    subject: 'Opetusaineet',
                    isadmin: 'Ylläpitäjä',
                    ofduty: 'Vapaalla',
                    logs: 'Loki',
                    status: 'Tila',
                    application: 'Palvelut',
                },
                page: {
                    add_pupils_title: 'Lisää luokalle oppilaita',
                    delete: 'Poista oppilas',
                    create: 'Lisää oppilas',
                    fromfile: 'Lisää CSV tiedostosta',
                },
                status: {
                    0: 'aktiivinen',
                    1: 'Poistettu',
                    2: 'Rekisteröinti kesken',
                    3: 'Rekisteröitymätön',
                },
                help: {
                    never_used: 'Ei kirjautunut',
                    createform:
                        'Avainkoodi luodaan oppilaalle lisäyksen yhteydessä.',
                    createnewkey: 'Luo uusi avainkoodi oppilaalle',
                },
                empty_header: 'Ei oppilaita',
            },
            events: {
                name: 'Tapahtuma |||| Tapahtumat',
            },
            transfer: {
                name: 'Siirto/yhdistäminen |||| Siirto/yhdistäminen',
                fields: {
                    name: 'Ikoni',
                    item_type: 'Tyyppikoodi',
                    item_type_name: 'Tyyppi',
                    description_field1: 'Kuvaus 1',
                    description_field2: 'Kuvaus 2',
                    description_field3: 'Kuvaus 3',
                },
                filters: {
                    category: 'Sarja',
                    status: 'Tila',
                    type: 'Tyyppi',
                    languages: 'Kieli',
                    target_persons: 'Kohderyhmä',
                    kouluasteet: 'Kouluaste',
                    applications: 'Aplikaatiot',
                },
            },
            subproduct: {
                empty_header: 'Ei alituotteita',
                empty_message: 'Lisää alituotteita alla olevalla lomakkeella.',
            },
            product: {
                name: 'Tuote |||| Tuotteet',
                fields: {
                    id: 'Tilauslinkki',
                    name: 'Nimi',
                    'public.alternative_name': 'Vaihtoehtoinen nimi',
                    'private.tuoterekisteri_data.tuotenimi':
                        'Nimi tuoterekisterissä',
                    'public.category': 'Kirjasarja',
                    //language: 'Kieli',
                    'public.languages': 'Kielet',
                    'public.target_persons': 'Kohderyhmä',
                    'public.show_testusage_button': 'Näytä koekäyttö-painike',
                    'public.kouluasteet': 'Kouluaste',
                    'public.applications': 'Applikaatiot joissa näytetään',
                    status: 'Tila',
                    'public.product_type': 'Tuotetyyppi',
                    'public.modules': 'Moduulit',
                    'public.not_period_license': 'Ei kausilisenssituote',
                    is_group: 'Ryhmä',
                    'public.materialstorage.isbn': 'ISBN',
                    'public.materialstorage.alternative_isbn':
                        'ISBN (vikasieto)',
                    path: 'Polku',
                    filename: 'Tiedosto',
                    show_only_in_list: 'Näkyvyys',
                    show_only_in_list_input: 'Älä näytä yksittäisenä tuotteena',
                    show_only_to_subscribers: 'Näytä vain tilaajille',
                    'public.dont_show_as_main_product':
                        'Näytä päätuotteena vain tilaajille',
                    'public.dont_show_as_sub_product':
                        'Älä näytä alituotteena Novassa',
                    free_to_download: 'Tuote on ilmainen',
                    'public.default_license_type': 'Lisenssityyppi',
                    'public.default_license_period': 'Lisenssin oletuskesto',
                    'public.disable_extra_material':
                        'Älä salli käyttöönottoa ISBN:llä',
                    'public.is_saamelaiskaraja': 'Saamelaiskäräjätuote',
                    'public.default_trial_period': 'Koekäytön oletuskesto',
                    'public.materialstorage.mime_type': 'Tiedostotyyppi',
                    'public.materialstorage.path': 'Polku',
                    materialstorage_guid: 'Materiaalivarasto',
                    description: 'Esittelyteksti/Markkinointiteksti',
                    'private.tuoterekisteri_data.saatavuus': 'Saatavuus',
                    'private.tuoterekisteri_data.tl_tuote_esittelyteksti_info':
                        'Esittelyteksti/Markkinointiteksti',
                    'private.tuoterekisteri_data.kantanumero': 'Kantanumero',
                    'public.subject': 'Opetusaine',
                    'public.additional_subjects': 'Muut opetusaineet',
                    'public.imprint': 'Kustantaja',
                    'public.course': 'Kurssi',
                    'public.element': 'Elementti',
                    'public.class_level': 'Luokka-aste',
                    'public.productgroup': 'Tuoteryhmä',
                    'public.is_for_extra': 'Kuuluu lukion käyttäjäetuihin',
                    'public.is_package': 'Pakettituote',
                    is_for_extra_first:
                        'Kuuluu lukion ensimmäisen vuoden käyttäjäetuihin',
                    'public.show_high_school_groups':
                        'Kuuluu lukion ryhmävalintaan',
                    'public.release_date': 'Lisätieto',
                    'public.free_to_download': 'Ilmainen',
                    'public.free_for_extra': 'Vanhoille käyttäjille',
                    order: 'Järjestä',
                    'public.sumplattava': 'Tuote on sumplattava',
                    'public.analytics': 'Tuotteella on analytiikka',
                    saatavuus: 'Saatavuus',
                    modules: 'Moduulit',
                    'public.extendable': 'Lisenssi on jatkettavissa',
                    'public.extendable_days': 'Jatkoaika päivinä',
                    'user.firstname': 'Etunimi',
                    'user.lastname': 'Sukunimi',
                    'user.email': 'Sähköposti',
                    'license.valid_from': 'Mistä',
                    'license.valid_until': 'Mihin',
                    'subscriber.name': 'Tilaaja',
                    'subscription.name': 'Jaettu / Tilattu',
                    preview: 'Esikatselu',
                },
                filters: {
                    category: 'Sarja',
                    category_close: 'Sarja',
                    status: 'Tila',
                    status_close: 'Tila',
                    type: 'Tyyppi',
                    type_close: 'Tyyppi',
                    languages: 'Kieli',
                    languages_close: 'Kieli',
                    target_persons: 'Kohderyhmä',
                    target_persons_close: 'Kohderyhmä',
                    kouluasteet: 'Kouluaste',
                    kouluasteet_close: 'Kouluaste',
                    applications: 'Applikaatiot',
                    applications_close: 'Applikaatiot',
                    materialstorage: 'Materiaalivarasto',
                    materialstorage_close: 'Materiaalivarasto',
                    kvstatus: 'Saatavuus',
                    kvstatus_close: 'Saatavuus',
                },
                tabs: {
                    details: 'Perustiedot',
                    extra_details: 'Lisätiedot',
                    redirect_details: 'Ohjaustiedot',
                    tuotelista_details: 'Tuoterekisteritiedot',
                    history_details: 'Historia',
                    sub_details: 'Liitetyt tuotteet',
                    modify_history: 'Muutoshistoria',
                    usage_history: 'Käyttöhistoria',
                    licenses: 'Lisenssit',
                },
                warnings: {
                    title: 'Tuote ei näy käyttäjälle',
                    subtitle: 'Tarkista alla olevat tiedot',
                    status: 'Tuote ei ole julkinen',
                    applications: 'Tuotteen näyttöpaikka ei täsmää',
                    target_persons: 'Tuotteen kohderyhmä ei täsmää',
                },
            },
            subscription: {
                name: 'Tilaus |||| Tilaukset',
                fields: {
                    name: 'Nimi',
                    subscriber: 'Tilaaja',
                    product: 'Tuote',
                    product_guid: 'Tuote',
                    subscriber_guid: 'Tilaaja',
                    valid_from: 'Mistä',
                    valid_until: 'Mihin',
                    valid_season: 'Voimassa',
                    license_count: 'Ostettu',
                    used_license_count: 'Lunastettu',
                    used_license_teacher_count: 'Käytössä',
                    unused_license_count: 'Vapaana',
                    type: 'Lisenssityyppi',
                    product_code: 'Tuotekoodi',
                    activate_code: 'Aktivointikoodi',
                    message: 'Muutoksen syy',
                    license_user_name: 'Käyttäjä',
                    license_created_date: 'Käyttöönotto',
                    license_modified_date: 'Muokattu',
                    status: 'Tila',
                    srcond: 'Kohdistus',
                    created_start: 'Luotu (mistä)',
                    created_end: 'Luotu (mihin)',
                    modified_start: 'Päivitetty (mistä)',
                    modified_end: 'Päivitetty (mihin)',
                    created: 'Luotu',
                    modified: 'Päivitetty',
                    'product.name': 'Tuote',
                    'subscriber.name': 'Tilaaja',
                    'public.kausi': 'Kausi',
                    'public.kvean': 'EAN',
                    'public.kvnro': 'Tilausnumero(t)',
                    'public.kvsource': 'Lähde',
                    'public.kvetumaara': 'Etumäärä',
                    'public.kvkoulukoodi': 'Koulukoodi',
                    'public.kvtilausmaara': 'Tilausmäärä',
                    combination_of_licenses: 'Til./Etu/Muu',
                    'product.status': '',
                },
                filters: {
                    status: 'Tila',
                    status_close: 'Tila',
                    products: 'Tuote',
                    'products.search': 'Anna hakusanat',
                    products_close: 'Tuote',
                    subscribers: 'Tilaaja',
                    'subscribers.search': 'Anna hakusanat',
                    subscribers_close: 'Tilaaja',
                    isvalid: 'Voimassaolo',
                    isvalid_close: 'Voimassaolo',
                    activationcode: 'Aktivointikoodi',
                    activationcode_search: 'Syötä aktivointikoodi',
                    activationcode_found:
                        'Aktivointikoodi on käytetty ja tilaus löytyi',
                    activationcode_not_found:
                        'Aktivointikoodilla ei löydy tilausta Storialta',
                    activationcode_not_found_title:
                        'Aktivointikoodi - ei löytynyt',
                    activationcode_not_activated:
                        'Tuotetta ei ole vielä otettu käyttöön',
                    activationcode_not_activated_title:
                        'Aktivointikoodi - ei aktivoitu',
                    activationcode_activated_title:
                        'Aktivointikoodi - aktivoitu',
                    activationcode_activated_at: 'Aktivoitu',
                    activationcode_invalid:
                        'Aktivointikoodin muoto on virheellinen (esim. YWA4-32HF-YFVJ-9EK4-B4R7)',
                },
                tabs: {
                    details: 'Perustiedot',
                    license_details: 'Käytössä',
                    messages: 'Muistiinpanot',
                    public_details: 'Ohjaustiedot',
                    private_details: 'Tuoterekisteritiedot',
                    log: 'Tapahtumaloki',
                    modify_history: 'Muutoshistoria',
                    usage_history: 'Käyttöhistoria',
                    groups: 'Ryhmät',
                    kv: 'Kirjavälitys',
                },
                page: {
                    add_license: 'Jaa lisenssi',
                },
                action: {
                    accept: 'Lisää yksi',
                    reject: 'Poista yksi',
                },
                actions: {
                    remove: {
                        title: 'Huom !',
                    },
                },
                notification: {
                    approved_success: 'Lisäys onnistui',
                    approved_error: 'Virhe: Lisäys epäonnistui',
                    rejected_success: 'Poisto onnistui',
                    rejected_error: 'Virhe: Poisto epäonnistui',
                },
                license_status: {
                    0: 'Käytössä',
                    1: 'Poistettu',
                    2: 'Annettu',
                },
                license_action: {
                    delete: 'Poista',
                    unuse: 'Vapauta',
                },
                status: {
                    0: 'Julkinen',
                    1: 'Poistettu',
                },
                srcond: {
                    1: 'Kohdistamattomat',
                    2: 'Kohdistetut',
                },
            },
            userlicense: {
                name: 'Lisenssi |||| Lisenssit',
                fields: {
                    lastname: 'Sukunimi',
                    firstname: 'Etunimi',
                    email: 'Sähköposti',
                    product: 'Tuotenimi',
                    product_isbn: 'ISBN',
                    licenses: 'Lisenssit',
                    groups: 'Valitse ryhmä',
                    nrosrc: 'Lisenssin numero',
                    usersrc: 'Käyttäjä',
                },
                seasons: {
                    label: 'Voimassaolokausi',
                    all: 'Kaikki',
                    previous: 'Edellinen',
                    current: 'Kuluva',
                    future: 'Tulevat',
                },
            },
            userlist: {
                name: 'Käyttäjä |||| Käyttäjät',
                fields: {
                    lastname: 'Sukunimi',
                    firstname: 'Etunimi',
                    middlename: 'Toinen nimi',
                    username: 'Tunnus',
                    email: 'Sähköposti',
                    role: 'Rooli',
                    subjects: 'Opetusaineet',
                    code: 'Avainkoodi',
                },
            },
            school: {
                label: 'Oppilaitos',
                name: 'Oppilaitos |||| Oppilaitokset',
                fields: {
                    empty: '(Ei annettu)',
                    empty_web_code:
                        'Verkkokauppatunnusta ei löytynyt, ota yhteys Otavan asiakaspalveluun',
                    category_id: 'Categor',
                    name: 'Nimi',
                    keyfields: 'Avaintiedot',
                    keyfields_more:
                        'Avaintiedot (koulukoodi, -tyyppi ja -paikka)',
                    material: 'Materiaali',
                    public: {
                        hidepages: 'Piilota käyttäjiltä',
                        categories: 'Sarjat',
                        features: 'Debug features',
                        address: 'Postiosoite',
                        city: 'Kaupunki',
                        code: 'Koulukoodi',
                        name: 'Nimi',
                        type: 'Koulutyyppi',
                        school_email: 'Koulun virallinen sähköposti sääntö',
                        phone_1: 'Opettajahuoneen puhelin 1',
                        phone_2: 'Opettajahuoneen puhelin 2',
                        location: 'Paikka',
                        zip_code: 'Postinumero',
                        grade_max: 'Ylin luokka-aste',
                        grade_min: 'Alin luokka-aste',
                        headmaster: 'Rehtori',
                        identifier: 'Tunniste',
                        shop_password: 'Salasana',
                        visit_city: 'Käynti kaupunki',
                        last_checked: 'Viimeisin tarkistus',
                        office_phone: 'Kanslian puhelin',
                        visit_address: 'Käynti osoite',
                        visit_zip_code: 'Käynti postinumero',
                        headmaster_email: 'Rehtorin sähköposti',
                        headmaster_phone: 'Rehtorin puhelin',
                        headmaster_cellphone: 'Rehtorin gsm',
                        number_of_pupils: 'Oppilaiden lukumäärä',
                        number_of_teachers: 'Opettajien lukumäärä',
                        grades: 'Luokka-asteet',
                        web_code: 'Verkkokauppatunnus',
                    },
                    'private.services.crm.crmGUID': 'CRM -linkki',
                    'private.aspa_info': 'Muistiinpanot',
                },
                filters: {
                    types: 'Koulutyypit',
                    types_close: 'Koulutyypit',
                    type_groups: 'Koulutyyppiryhmät',
                    type_groups_close: 'Koulutyyppiryhmät',
                    status: 'Tila',
                    status_close: 'Tila',
                    adminstatus: 'Ylläpitäjät',
                    adminstatus_close: 'Ylläpitäjät',
                    teacherstatus: 'Opettajat',
                    teacherstatus_close: 'Opettajat',
                    pupilstatus: 'Oppilaat',
                    pupilstatus_close: 'Oppilaat',
                    studentstatus: 'Opiskelijat',
                    studentstatus_close: 'Opiskelijat',
                    subscriptionstatus: 'Tilaukset',
                    subscriptionstatus_close: 'Tilaukset',
                },
                actions: {
                    show_web_shop_code: 'Näytä verkkokauppatunnus',
                    remove: {
                        title: 'Huom !',
                        ask: 'Poista käyttäjä oppilaitoksesta %{name}',
                        description:
                            'Poistetaanko käyttäjä oppilaitoksesta %{name} ?',
                    },
                    add: {
                        title: 'Huom !',
                        ask: 'Palauta käyttäjä oppilaitokseen %{name}',
                        description:
                            'Palautetaanko käyttäjä oppilaitokseen %{name} ?',
                    },
                },
                page: {
                    manage_license: 'Oppilaslisenssit',
                    pupil_license: {
                        addall: 'Valitse kaikki',
                        removeall: 'Poista valinnat',
                        chosen: 'Valittu',
                    },
                    student_license: {
                        code: 'Aktivointikoodi',
                        name: 'Nimi',
                        aktivated: 'Käyttöönotto',
                    },
                    web_code:
                        'Verkkokauppatunnusta käytetään Otavan verkkokaupassa.',
                    web_code_username: 'Tunnus: %{username}',
                    web_code_password: 'Salasana: %{password}',
                    orders: {
                        pupil: 'Koulun oppilaslisenssit',
                        school: 'Koulun opetusaineistojen ja digikirjojen lisenssit',
                        past: 'Vanhentuneet',
                        active: 'Voimassa olevat',
                        future: 'Tulevat',
                    },
                },
                help: {
                    manage_license: {
                        product: 'Materiaali',
                        hint: 'Valitse materiaali',
                        beforeProductSelected:
                            'Aloita oppilaslisenssien jakaminen valitsemalla materiaali alla olevasta pudotusvalikosta.',
                        afterProductSelected:
                            'Valitse listalta oppilaat, joille haluat lisätä oppilaslisenssin. Muista lopuksi tallentaa muutokset klikkaamalla Tallenna painiketta. Oppilaat ovat listattu luokittain. Voit tarvittaessa vielä lisätä uusia oppilaita luokkiin klikkaamalla lisää oppilas painiketta luokan kohdalta.',
                        afterProductSelected2:
                            'Voit myös poistaa oppilaslisenssin oppilaalta, joka ei vielä ole käyttänyt materiaalia.',
                    },
                },
                tabs: {
                    details: 'Perustiedot',
                    subscription: 'Tilaukset',
                    groups: 'Ryhmät',
                    teachers: 'Opettajat',
                    pupils: 'Oppilaat',
                    students: 'Opiskelijat',
                    stats: 'Tilastot',
                },
                organization: {
                    not_found:
                        'Organisaatiotietoja ei löytynyt Opintopolku-palvelusta. Tarkista koulukoodi.',
                    error: 'Virhe haettaessa organisaatiotietoja',
                    inactive: 'Organisaatio ei ole aktiivinen',
                },
            },
            group: {
                name: 'Ryhmä |||| Ryhmät',
                fields: {
                    name: 'Nimi',
                    status: 'Tila',
                    parent_group: 'Oppilaitos',
                    schools_name: 'Oppilaitokset',
                    'public.code': 'Liittymiskoodi',
                    'public.group_type': 'Ryhmätyyppi',
                    'public.archived': 'Arkistoitu',
                    author: {
                        creator: 'Luoja',
                        created: 'Luotu',
                        modifier: 'Muokkaaja',
                        modified: 'Muokattu',
                    },
                    archived: 'Arkistoitu',
                    settings: {
                        allowOnlySameSchool:
                            'Salli vain sama koulun oppilaille',
                        allowOnlyMPASS: 'Salli vain MPASS-oppilaille',
                    },
                },
                tabs: {
                    details: 'Perustiedot',
                    teachers: 'Opettajat',
                    pupils: 'Oppilaat',
                    students: 'Opiskelijat',
                    settings: 'Asetukset',
                },
                filters: {
                    status: 'Tila',
                    status_close: 'Tila',
                    archived: 'Arkistointi',
                    archived_close: 'Arkistointi',
                    schools: 'Oppilaitokset',
                    schools_close: 'Oppilaitokset',
                    'schools.search': 'Hae oppilaitosta',
                },
            },
            usergroup: {
                empty_header: 'Ei luokkia',
                filters: {
                    onlyactive: 'Vain aktiiviset ryhmät',
                },
                status: {
                    0: 'Aktiivinen',
                    1: 'Poistettu',
                },
            },
            campaign: {
                name: 'Kampanja |||| Kampanjat',
                filters: {
                    search: 'Hae kampanjan nimellä',
                    all: 'Kaikki',
                    ongoing: 'Käynnissä',
                    upcoming: 'Tuleva',
                    ended: 'Päättynyt',
                    inactive: 'Passivoitu',
                    period: 'Voimassa valitulla aikavälillä',
                    from: 'Alkupäivä',
                    until: 'Loppupäivä',
                    invalid_dates: 'Loppupäivä ei voi olla ennen alkupäivää.',
                    period_help: 'Näyttää kampanjat, joiden voimassaoloaika osuu edes osittain valittuun aikaväliin. Päivämäärät Suomen ajassa.',
                },
                fields: {
                    name: 'Kampanjan nimi',
                    start_date: 'Alkaa',
                    end_date: 'Päättyy',
                    books: 'Kirjat',
                    isbn: 'ISBN',
                    title: 'Kirjan nimi',
                    targets: 'Kohderyhmä',
                    target_type: 'Kohdelistan tunnistetyyppi',
                    target_list: 'Kohdelista',
                    created: 'Luotu',
                    csv_email: 'CSV-viennin vastaanottaja',
                    csv_weekdays: 'Vientipäivät (ma,ti,ke,to,pe,la,su)',
                    csv_time: 'Vientiaika (Suomen aika, HH:mm)',
                    settings_json: 'Muut kampanja-asetukset (JSON)',
                    export_schedule: 'CSV-vienti',
                    target_count: 'Kohderyhmä',
                    responded_count: 'Vastanneet',
                    response_rate: 'Vastausprosentti',
                    accepted_count: 'Hyväksyneet',
                    rejected_count: 'Hylänneet',
                    user_guid: 'Käyttäjän GUID',
                    user_name: 'Opettaja',
                    school_guid: 'Koulun GUID',
                    school_name: 'Koulu',
                    selected_books: 'Valitut ISBN:t',
                    responded_at: 'Vastattu',
                    status: 'Tila',
                },
                actions: {
                    template: 'Excel-pohja',
                    export_workbook: 'Lataa kampanja Excel-pohjaksi',
                    import: 'Tuo kampanja',
                    export: 'Lataa hyväksytyt tilaukset CSV:nä',
                    exporting: 'Ladataan…',
                    export_responses: 'Lataa kaikki vastaukset CSV:nä',
                    exporting_responses: 'Ladataan vastauksia…',
                    email: 'Lähetä hyväksytyt tilaukset sähköpostilla',
                    emailing: 'Lähetetään…',
                },
                status: {
                    active: 'Aktiivinen',
                    inactive: 'Passivoitu',
                    pending: 'Vastaamatta',
                    accepted: 'Hyväksytty',
                    rejected: 'Hylätty',
                },
                target_types: {
                    user_guid: 'Nova-käyttäjän GUID',
                    crm_guid: 'CRM GUID',
                },
                helpers: {
                    target: 'Lisää yksi GUID riville. Valitse yllä, ovatko tunnisteet Nova-käyttäjien vai CRM:n GUID-tunnisteita.',
                    status: 'Aktiivinen kampanja näkyy opettajille voimassaoloaikanaan. Passivoitu kampanja ei näy opettajille, siihen ei voi vastata eikä siitä lähetetä ajastettuja CSV-vientejä. Manuaaliset viennit ovat edelleen käytettävissä.',
                    csv_email: 'Sähköpostiosoite, johon kampanjan hyväksytyt tilaukset lähetetään CSV-tiedostona. Jätä tyhjäksi, jos haluat käyttää hallinnan asetuksissa määritettyä oletusvastaanottajaa.',
                    weekdays: 'Anna päivät pilkuilla eroteltuina, esim. ma,ke,pe. Tyhjä = vain manuaalinen vienti.',
                    time: '24 tunnin Suomen paikallisaika.',
                    settings: 'Muut kampanja-asetukset JSON-objektina.',
                },
                tabs: {
                    details: 'Kampanjan tiedot',
                    responses: 'Kohderyhmä ja vastaukset',
                    daily_report: 'Päiväraportti',
                    export_history: 'Lähetyshistoria',
                },
                daily_report: {
                    date: 'Päivä',
                    responses: 'Vastaukset päivittäin',
                    books: 'Valitut kirjat päivittäin',
                    selected_books: 'Kirjoja yhteensä',
                    total: 'Yhteensä',
                    empty: 'Kampanjaan ei ole vielä vastauksia.',
                    description: 'Vastauspäivät Suomen ajassa. Kirjamäärä kertoo, kuinka moni hyväksynyt valitsi kyseisen ISBN:n. Vain vastauspäivät näytetään.',
                },
                delivery_report: {
                    time: 'Ajankohta',
                    type: 'Lähetystapa',
                    status: 'Tila',
                    attempts: 'Yritykset',
                    error_detail: 'Virhe',
                    empty: 'Kampanjasta ei ole vielä CSV-lähetyksiä.',
                    error: 'Lähetystietojen lataus epäonnistui.',
                    description: 'Näyttää ajastetut cron-ajot ja manuaaliset CSV-sähköpostit. Lähetetty tarkoittaa, että Mailgun hyväksyi viestin; vastaanottajalle toimitusta ei vahvisteta.',
                    types: {
                        scheduled: 'Ajastettu cron',
                        manual: 'Manuaalinen',
                    },
                    statuses: {
                        sending: 'Lähetetään',
                        sent: 'Lähetetty',
                        failed: 'Epäonnistui',
                    },
                },
                import_success: 'Kampanja tuotu Excelistä.',
                template_error: 'Excel-pohjan lataus epäonnistui.',
                workbook_error: 'Kampanjan Excel-vienti epäonnistui.',
                export_error: 'CSV-vienti epäonnistui.',
                email_success: 'Vastaukset lähetetty kampanjan CSV-vastaanottajalle.',
                email_error: 'Vastausten sähköpostilähetys epäonnistui.',
                recipient_missing: 'CSV-vastaanottajaa ei ole määritelty.',
                responses_error: 'Vastausten lataus epäonnistui.',
                manual_export: 'Manuaalinen',
            },
            announcement: {
                name: 'Tiedote |||| Tiedotteet',
                fields: {
                    name: 'Nimi',
                    'public.message': 'Teksti',
                    'public.read_more':
                        'Lue lisää linkki (kirjoita muotoon https://)',
                    valid_from: 'Mistä',
                    valid_until: 'Mihin',
                    valid_season: 'Voimassa',
                    status: 'Tila',
                    'public.applications': 'Palvelut',
                    'public.imprint': 'Kustantaja',
                    placements: 'Sijainti',
                    'public.languages': 'Kieli',
                    'public.categories': 'Sarjat',
                    'public.types': 'Koulutyypit',
                    'public.tags':
                        'ISBN kohdennus (pilkkueroiteltu lista ISBN:stä)',
                    'public.typegroups': 'Koulutyyppiryhmät',
                    timestamp: 'Muokattu',
                    'public.announcement_type': 'Tiedotetyyppi',
                    created: 'Luotu',
                    modified: 'Muokattu',
                    creator_name: 'Luoja',
                    modifier_name: 'Muokkaaja',
                    author: {
                        creator: 'Luoja',
                        created: 'Luotu',
                        modifier: 'Muokkaaja',
                        modified: 'Muokattu',
                    },
                },
                filters: {
                    status: 'Tila',
                    status_close: 'Tila',
                    languages: 'Kieli',
                    languages_close: 'Kieli',
                    applications: 'Applikaatiot',
                    applications_close: 'Applikaatiot',
                    announcement_types: 'Tiedotetyyppi',
                    announcement_types_close: 'Tiedotetyyppi',
                    online_status: 'Voimassaolo',
                    online_status_close: 'Voimassaolo',
                },
                tabs: {
                    details: 'Perustiedot',
                },
                notification: {
                    approved_success: 'Lisäys onnistui',
                    approved_error: 'Virhe: Lisäys epäonnistui',
                    rejected_success: 'Poisto onnistui',
                    rejected_error: 'Virhe: Poisto epäonnistui',
                },
                status: {
                    0: 'Julkinen',
                    1: 'Poistettu',
                    2: 'Luonnos',
                },
                language: {
                    fin: 'Suomenkielinen',
                    swe: 'Ruotsinkielinen',
                    eng: 'Englanninkielinen',
                },
                application: {
                    oppimisenpalvelut: 'oppimisenpalvelut.otava.fi',
                    opepalvelu: 'opepalvelu.otava.fi',
                    opepalvelubeta: 'opepalvelu-beta.otava.fi',
                    oppilas: 'oppilas.otava.fi',
                    opiskelija: 'opiskelija.otava.fi',
                    finnlectura: 'finnlectura',
                    finnlectura_opiskelija: 'opiskelija.finnlectura.fi',
                    finnlectura_opettaja: 'opettaja.finnlectura.fi',
                },
                placement: {
                    1: 'Ylä banneri',
                    2: 'Ylä banneri alempi',
                    3: 'Sarjan yhteydessä',
                    4: 'Uutinen sarjan yhteydessä',
                    5: 'Viestilaatikossa',
                },
            },
            application: {
                label: 'Palvelu',
                name: 'Palvelu |||| Palvelut',
                actions: {
                    remove: {
                        title: 'Huom !',
                        ask: 'Poista käyttäjä palvelusta %{name}',
                        description:
                            'Poistetaanko käyttäjä palvelusta %{name} ?',
                    },
                },
                tabs: {
                    details: 'Perustiedot',
                },
                fields: {
                    last_login: 'Kirjautunut',
                    registered: 'Rekisteröitynyt',
                    name: 'Nimi',
                    username: 'Sähköposti',
                    alternative_isbn_in_use: 'Korvaava ISBN käytössä',
                    alternative_exclude_materialstorage:
                        'Älä käytä näissä materiaalivarastoissa',
                    alternative_exclude: 'Älä käytä näillä ISBN:llä',
                    alternative_isbn_text_fi: 'Suomenkielinen teksti',
                    alternative_isbn_text_sv: 'Ruotsinkielinen teksti',
                },
                status: {
                    0: 'aktiivinen',
                    1: 'Poistettu',
                },
                role: {
                    400: 'Superkäyttäjä',
                    300: 'Pääkäyttäjä',
                    250: 'Tuotepäivittäjä',
                },
            },
            valkey: {
                name: 'Valkey |||| Valkey',
                fields: {
                    key: 'Avain',
                    value: 'Arvo',
                    ttl: 'TTL (s)',
                    size: 'Koko',
                    type: 'Tallennustyyppi',
                },
                filters: {
                    pattern: 'Hae avaimia (wildcard: *)',
                },
                actions: {
                    delete_confirm: 'Haluatko varmasti poistaa avaimen %{key}?',
                },
            },
            materialstorage: {
                name: 'Materiaalivarasto |||| Materiaalivarastot',
                fields: {
                    name: 'Nimi',
                    path: 'Polku',
                    status: 'Tila',
                    'public.sso': 'SSO',
                    'public.redirtoken': 'Uudelleenohjaus-token',
                    'public.prewarm': 'Ennakoiva päivitys (prewarm)',
                    'public.prewarm_help':
                        'Kun päällä, tämän materiaalin klikkaus päivittää käyttäjän lisenssi- ja opettajavälimuistit ennakoivasti ennen kumppani-API:n kutsua (ks. hallinta -> asetukset -> Kumppani-API ja lisenssitarkistuksen välimuisti).',
                    created: 'Luotu',
                    modified: 'Muokattu',
                    creator_name: 'Luoja',
                    modifier_name: 'Muokkaaja',
                    author: {
                        creator: 'Luoja',
                        created: 'Luotu',
                        modifier: 'Muokkaaja',
                        modified: 'Muokattu',
                    },
                },
                notification: {
                    approved_success: 'Lisäys onnistui',
                    approved_error: 'Virhe: Lisäys epäonnistui',
                    rejected_success: 'Poisto onnistui',
                    rejected_error: 'Virhe: Poisto epäonnistui',
                },
            },
            secrets: {
                name: 'Secrets Manager |||| Secrets Manager',
                fields: {
                    name: 'Nimi',
                    description: 'Kuvaus',
                    secretString: 'Arvo',
                    createdDate: 'Luotu',
                    lastChangedDate: 'Viimeksi muokattu',
                    lastAccessedDate: 'Viimeksi käytetty',
                    deletionDate: 'Poistopäivä',
                    tags: 'Tunnisteet',
                    versionId: 'Versio',
                },
                helpers: {
                    name: 'Nimi alkaa etuliitteellä infra2/',
                },
            },
            logevent: {
                s: {
                    filter: {
                        date_from: 'Mistä',
                        date_to: 'Mihin',
                    },
                    fields: {
                        date: 'Ajankohta',
                        author: 'Käyttäjä',
                        title: 'Lisenssimäärä',
                        subtitle: 'Lisenssimäärän muutos',
                        description: 'Viesti',
                    },
                },
                p: {
                    filter: {
                        date_from: 'Mistä',
                        date_to: 'Mihin',
                    },
                    fields: {
                        date: 'Ajankohta',
                        author: 'Käyttäjä',
                        title: '',
                        subtitle: 'Private',
                        description: 'Public',
                    },
                },
            },
            locks: {
                overlay: 'Currently Edited by %{name}',
            },
        },
        login: {
            otava_ad: 'Otava kirjautuminen',
            otava_ad_success: 'Jatka palveluun',
            otava_ad_failure: 'Jatka kirjautumis sivulle',
            nonce_mismatch:
                'Tunnuksellasi on kirjauduttu toisessa selaimessa. Kirjaudu uudelleen.',
            no_token: 'Kirjaudu sisään',
        },
        statistics: {
            title: 'Tilasto |||| Tilastot',
            nodata: 'Ei dataa valitulla ajanjaksolla',
            noaccess: 'Ei käyttöoikeutta',
            modes: {
                single: 'Luku',
                list: 'Taulukko',
                graph: 'Kaavio',
            },
            fields: {
                teachers: 'Opettajat',
                pupils: 'Oppilaat',
                students: 'Opiskelijat',
                all: 'Kaikki',
                from: 'Mistä',
                timestamp: 'Ajankohta',
                level: 'Taso',
                product_guid: 'Tuote',
                message: 'Tapahtuma',
                subscription_guid: 'Tilaus',
                school_guid: 'Oppilaitos',
                group_guid: 'Ryhmä',
                user_agent: 'Selain',
                tags: 'Tunnisteet',
                ip: 'IP',
                show_more: 'Näytä lisää',
            },
            periods: {
                day: 'Päivä',
                week: 'Viikko',
                month: 'Kuukausi',
                year: 'Vuosi',
                startperiod: 'Kauden alusta (1.8.)',
                days30: 'Viimeiset 30 päivää',
                days90: 'Viimeiset 90 päivää',
            },
            activesessions: {
                title: 'Aktiiviset istunnot',
                tooltip: 'Käyttäjällä on aktiivinen istunto palvelussa',
            },
            activeusers: {
                title: 'Aktiiviset käyttäjät',
                tooltip: 'Palvelussa aktiivisena olleet %{day} päivän aikana',
            },
            activeusershistory: {
                title: 'Aktiiviset käyttäjät – historia',
                tooltip:
                    'Aktiivisten käyttäjien kehitys päivittäin/kuukausittain',
                show_page: 'Näytä historia',
                daily: 'Päivittäin',
                monthly: 'Kuukausittain',
                schoolyear: 'Lukuvuosi',
                showtotal: 'Näytä yhteensä',
                chart: 'Kaavio',
                table: 'Taulukko',
                export: 'Vie Exceliin',
                date: 'Päivämäärä',
                range: 'Aikaväli',
                custom: 'Mukautettu',
                from: 'Alkaen',
                to: 'Päättyen',
                pickrange: 'Valitse kelvollinen aikaväli.',
                holidays: 'Näytä lomat',
            },
            stale: {
                label: 'Tiedot klo %{time}',
                tooltip:
                    'Tilastopalvelu ei vastannut ajoissa, joten näytetään viimeisin tallennettu tulos.',
            },
            dataconfirmations: {
                title: 'Tietojen vahvistukset',
                current: 'Tietojen nykytilanne',
                own: 'Omat tiedot',
                school: 'Koulutiedot',
                own_current: 'Itse vahvistetut omat tiedot, ajan tasalla',
                requires_check: 'Omat tiedot vaativat tarkistamista',
                school_requires_check:
                    'Opettajat, joilla koulusuhde vaatii tarkistamista',
                school_current: 'Itse vahvistetut koulutiedot, ajan tasalla',
                role: 'Rooli',
                roles: {
                    teacher: 'Opettajat',
                    student: 'Opiskelijat',
                    pupil: 'Oppilaat',
                },
                all_roles: 'Kaikki roolit',
                group_by: 'Ryhmittely',
                day: 'Päivä',
                month: 'Kuukausi',
                last_login_from: 'Kirjautunut aikaisintaan',
                all_active: 'Kaikki aktiiviset käyttäjät',
                open: 'Näytä vahvistusten jakauma',
                distribution: 'Viimeisimpien vahvistusten jakauma',
                period_totals:
                    'Viimeisin vahvistus valitulla aikavälillä / valittu käyttäjäjoukko',
                widget_scope:
                    'Viimeisen 12 kk aikana kirjautuneet aktiiviset käyttäjät. Tarkistusraja %{days} vrk. Itse vahvistetut ja tarkistusta vaativat eivät ole toistensa vastakohtia.',
                distribution_note:
                    'Tämä ei ole tapahtumahistoria: jokainen käyttäjä lasketaan roolia kohti vain viimeisimmän vahvistuksensa päivälle tai kuukaudelle. Uusi vahvistus siirtää käyttäjän pois aiemmasta jaksosta. Omien tietojen ja koulutietojen luvut ovat erillisiä, eikä niitä voi laskea yhteen eri käyttäjien määräksi.',
                current_note:
                    'Itse vahvistetut: vahvistus %{days} vrk sisällä, ei pakotettua tarkistuspyyntöä. Tarkistusta vaativat: profiilin tilan mukainen laskenta, joka huomioi myös luontiajan, käyttäjän oman muokkauksen ja pakotetun tarkistuspyynnön. Luvut eivät ole toistensa vastakohtia. Jakauman päivämäärärajaus ei muuta nykytilannetta.',
                school_note:
                    'Koulutietojen vahvistus koskee opettajia. Ajantasaisuuteen riittää yksi aktiivinen vahvistettu koulusuhde. Tarkistusta vaativiin lasketaan opettajat, joilla vähintään yksi aktiivinen koulusuhde vaatii tarkistamista, joten opettaja voi kuulua molempiin lukuihin. Vertailujoukkona ovat opettajat, joilla on aktiivinen koulusuhde; jakaumassa käytetään viimeisintä vahvistusta aktiivisista koulusuhteista.',
            },
            loginstats: {
                title: 'Kirjautumiset',
                tooltip: 'Kirjautumisyritykset %{day} päivän ajalta',
                success: 'Onnistuneet',
                failed: 'Epäonnistuneet',
                nofailed: 'Ei epäonnistuneita kirjautumisia',
                failure_details: 'Epäonnistumisten syyt',
                codes: {
                    WRONG_PASSWORD: 'Väärä salasana',
                    USER_NOT_FOUND: 'Käyttäjää ei löydy',
                    PUPIL_NOT_FOUND: 'Oppilasta ei löydy',
                    APP_NOT_FOUND: 'Sovellusta ei löydy',
                    API_KEY_NOT_FOUND: 'API-avainta ei löydy',
                    TOO_MANY_LOGIN_ATTEMPTS:
                        'Tunnus lukittu (liian monta yritystä)',
                    USER_DELETED: 'Käyttäjä poistettu',
                    USER_NOT_APPROVED: 'Käyttäjää ei hyväksytty',
                    USER_NOT_ACTIVATED: 'Käyttäjää ei vahvistettu',
                    USER_LOGIN_NOT_ACTIVED: 'Tunnus ei aktiivinen',
                    USER_PROFILE_LOCKED: 'Profiili lukittu',
                    TURNSTILE_VALIDATION_FAILED:
                        'Turnstile-tarkistus epäonnistui',
                    TURNSTILE_TOKEN_MISSING: 'Turnstile-token puuttuu',
                    TURNSTILE_VERIFY_UNREACHABLE:
                        'Turnstile ei tavoitettavissa',
                    HASH_NOT_MATCH: 'Virheellinen tarkiste',
                    LOGIN_FAILED: 'Kirjautuminen epäonnistui',
                    DEVELOPER_TOKEN_ERROR: 'Kehittäjätunnuksen virhe',
                    BASIC_LOGIN_DISABLED: 'Perustunnistautuminen pois käytöstä',
                    INVALID_CLIENT_ID: 'Virheellinen client_id',
                    CLIENT_API_KEY_NOT_FOUND: 'API-avainta ei löydy (client)',
                    CLIENT_ENV_MISMATCH: 'Väärä ympäristö (client)',
                    MPASS_START_ERROR:
                        'MPASS-kirjautumisen aloitus epäonnistui',
                    MPASS_ERROR: 'MPASS-istunto vanhentunut tai virheellinen',
                    MPASS_NOT_VALID_ROLE:
                        'MPASS: käyttäjän MPASS-roolitiedoista ei löytynyt valittuun sovellukseen sopivaa roolia, eikä oikeaa sovellusta voitu päätellä automaattisesti.',
                    MPASS_NOT_VALID_SCHOOL_TYPE:
                        'MPASS: koulun tyyppi ei sovi valittuun sovellukseen (esim. oppilas lukioon tai opiskelija peruskouluun)',
                    MPASS_SCHOOL_NOT_FOUND:
                        'MPASS: käyttäjän koulua ei tunnisteta (koulukoodi ei täsmää Opintopolun tietoihin)',
                    TOKEN_WRITE_ERROR: 'Kirjautumistokenia ei löydy',
                    JSON_TOKEN_FORBIDDEN:
                        'JSON-token vaatii järjestelmänvalvojan oikeudet',
                    USER_ENVIRONMENT_RESTRICTED:
                        'Ei oikeuksia tähän ympäristöön',
                    OIDC_ERROR: 'OIDC-virhe',
                    GENERIC: 'Yleinen virhe',
                    UNKNOWN: 'Muu virhe',
                },
            },
            newusers: {
                title: 'Uudet käyttäjät',
                tooltip: 'Rekisteröityneet %{day} päivän aikana',
            },
            newusershistory: {
                title: 'Uudet käyttäjät – historia',
                tooltip: 'Uusien käyttäjien kehitys päivittäin/kuukausittain',
                show_page: 'Näytä historia',
                daily: 'Päivittäin',
                monthly: 'Kuukausittain',
                schoolyear: 'Lukuvuosi',
                chart: 'Kaavio',
                table: 'Taulukko',
                export: 'Vie Exceliin',
                date: 'Päivämäärä',
                range: 'Aikaväli',
                custom: 'Mukautettu',
                from: 'Alkaen',
                to: 'Päättyen',
                pickrange: 'Valitse kelvollinen aikaväli.',
                holidays: 'Näytä lomat',
            },
            producttransitions: {
                title: 'Tuoteavaukset',
                tooltip: 'TOP %{limit} tuoteavaukset %{day} päivän aikana',
                tooltip_limit: 'TOP %{limit} tuoteavaukset',
                tooltip_single: 'Tuoteavaukset %{day} päivän aikana',
            },
            userevents: {
                title: 'Käyttäjän tapahtumat',
                tooltip: 'TOP %{limit} tapahtumat %{day} päivän aikana',
                tooltip_single: 'Tapahtumat %{day} päivän aikana',
            },
            mpassbykunta: {
                title: 'MPASSid käyttö / Maakunta',
                tooltip: 'MPASSid osuus maakunnittain',
                show_on_map: 'Näytä kartalla',
                teachers: 'Opettajat',
                students: 'Opiskelijat',
                pupils: 'Oppilaat',
                schools: 'koulua',
            },
        },
        merge: {
            workspace: {
                help: 'Ohje',
                help_auto_open: 'Avaa ohje automaattisesti',
                help_overview: 'Työnkulku ja lisenssimerkinnät.',
                help_export: 'Vie tarkistusehdotus oppilaitokselle.',
                help_merge: 'Tarkista hyväksytyt tilit, päätili ja tunnus.',
                help_report: 'Vie raportti toteutuneista yhdistämisistä.',
                help_history: 'Tarkastele tehtyjä yhdistämisiä ja peruuta tarvittaessa.',
                license_legend_title: 'Lisenssimerkinnät',
                license_legend_valid: 'Lisenssi voimassa nyt',
                license_legend_not_valid: 'Aktiivinen lisenssi (ei voimassa nyt)',
                license_legend_extended: 'Jatkettu lisenssi (aiempia versioita)',
                license_legend_overlapping_sample: 'Koulun lisenssi',
                license_legend_overlapping: 'Täytetty merkintä = koulun päällekkäinen lisenssi',
                title: 'Tuplatilien hallinta',
                role: 'Käyttäjäryhmä',
                export: 'Vie tuplat Exceliin',
                merge: 'Yhdistäminen',
                report: 'Raportti',
                history: 'Yhdistämishistoria',
            },
            title: 'Yhdistäminen',
            nodata: 'Ei löydy yhdistettäviä tilejä',
            error: 'Yhdistäminen epäonnistui',
            inactive: 'Käyttäjä ei ole aktiivinen, tunnusta ei voi yhdistää',
            success: 'Yhdistäminen onnistui',
            button: 'Yhdistä',
            cancel: 'Peruuta',
            continue: 'Yhdistä kaikesta huolimatta',
            change_profile: 'Vaihda päätiliksi',
            search: {
                title: 'Hae',
                description:
                    'Hae päätiliin yhdistettävää käyttäjää. Hakuehto voi olla esim. sähköpostiosoite tai nimi.',
                must_be_same_school: 'Käyttäjän tulee olla samasta koulusta.',
                button: 'Hae',
            },
            from: {
                title: 'Yhdistettävä tili',
            },
            to: {
                title: 'Päätili',
            },
            conflict: {
                title: 'Havaitut ristiriidat',
                message:
                    'Varmista, että yhdistettävät tilit kuuluvat samalle käyttäjälle. Alla olevat tiedot ovat ristiriidassa.',
                last_login: 'Viimeisin kirjautuminen',
                firstname: 'Etunimi ei täsmää',
                lastname: 'Sukunimi ei täsmää',
                mpass: 'Molemmilla on MPASS liitos',
                school: 'Oppilaitos tiedot ei täsmää',
                restricted_material:
                    'Opettajan tilin yhdistämisessä otettava huomioon digikokeet: päätilin digikokeet säilyvät, mutta yhdistettävän tilin digikokeet (Otavan Koetyökalu / Cloubi 2 digikokeet) häviävät eivätkä siirry päätiliin',
            },
            profilepage: {
                title: 'Liitetyt tilit',
                description: 'Tunnukseen on liitetty alla olevat tilit.',
                license_currently_valid: 'Lisenssi voimassa nyt',
                license_not_currently_valid: 'Aktiivinen lisenssi ei ole voimassa nyt',
                license_overlapping:
                    'Sama aktiivinen koulun lisenssi on myös toisella tilillä',
                cancel_button: 'Peruuta yhdistäminen',
                cancel_confirm_title: 'Peruutetaanko yhdistäminen?',
                cancel_confirm_message:
                    'Yhdistetyn tilin tiedot (sähköposti/tunnus, ryhmät ja lisenssit) palautetaan erilliseksi tiliksi. Molempien tilien istunnot katkaistaan ja kirjautuminen vaaditaan uudelleen. Toimenpidettä ei voi perua.',
                cancel_deadline_passed:
                    'Peruutusaika on umpeutunut, yhdistämistä ei voi enää peruuttaa.',
                cancel_materials_merged:
                    'Materiaalit on jo yhdistetty, peruutus ei ole enää mahdollinen.',
                cancel_success: 'Yhdistäminen peruutettu',
                cancel_error: 'Yhdistämisen peruutus epäonnistui',
            },
            history: {
                mpass_status: 'MPASS-profiili',
                report_not_recorded: 'Ei tallennettu',
                report_estimate_help: 'Tähdellä merkityt tiedot perustuvat yhdistämishetkellä tallennettuun päällekkäisten tuotteiden laskelmaan ja lisenssilistoihin, eivät mitattuun lisenssikulutuksen muutokseen. Tarkka toteumatieto on aina ensisijainen.',
                report_missing_audit:
                    'Vanhoista yhdistämisistä voi puuttua vapautuneiden lisenssien määrä (”Ei tallennettu”), jota ei voi päätellä jälkikäteen.',
                mpass_moved: 'Siirretty',
                mpass_merged: 'Yhdistetty',
                mpass_retained: 'Säilyi',
                mpass_none: 'Ei profiilia',
                mpass_not_transferred: 'Ei siirretty',
                mpass_unknown: 'Ei tietoa',
                mpass_help: 'MPASS-tila yhdistämishetkellä.',
                mpass_cancelled: 'Ennen peruutusta',
                report_title: 'Oppilaitokselle toimitettava yhdistämisraportti',
                report_help:
                    'Raportti sisältää koulun perumattomat yhdistämiset joko viimeisimmältä yhdistämispäivältä tai valitulta aikaväliltä.',
                report_scope: 'Raportin rajaus',
                report_latest: 'Viimeisin yhdistämiserä',
                report_dates: 'Päivämääräväli',
                report_from: 'Alkupäivä',
                report_until: 'Loppupäivä',
                report_role: 'Käyttäjärooli',
                report_export: 'Vie Exceliin',
                report_primary_name: 'Säilyneen tilin nimi',
                report_primary_identifier: 'Säilyneen tilin aiempi kirjautumistunnus',
                report_source_name: 'Yhdistetyn tilin nimi',
                report_source_identifier: 'Yhdistetyn tilin aiempi kirjautumistunnus',
                report_identifier_after: 'Kirjautumistunnus yhdistämisen jälkeen',
                report_released_licenses: 'Palautuneet lisenssit (kpl)',
                report_released_products: 'Palautuneiden lisenssien tuotteet',
                report_show_products: 'Näytä tuotteet',
                report_unknown: 'Ei tietoa',
                report_note:
                    'Tiedot kuvaavat yhdistämishetkeä. Sisältää henkilötietoja: toimita vain asianomaiselle oppilaitokselle turvallista kanavaa käyttäen.',
                report_invalid_dates: 'Anna kelvollinen alku- ja loppupäivä oikeassa järjestyksessä.',
                report_empty: 'Valitussa rajauksessa ei ole perumattomia yhdistämisiä.',
                report_error: 'Yhdistämisraportin vienti epäonnistui.',
                select_page: 'Valitse tämän sivun peruttavissa olevat yhdistämiset',
                select_entry: 'Valitse yhdistäminen: %{identifier}',
                cancel_selected: 'Peruuta valitut (%{count})',
                cancel_confirm: 'Peruutetaan %{count} valittua yhdistämistä uusimmasta vanhimpaan. Ajo pysähtyy ensimmäiseen virheeseen.',
                cancel_progress: 'Peruutettu %{completed} / %{total}',
                cancel_result: 'Peruutettu %{completed} / %{total} yhdistämistä.',
                cancel_stopped: 'Ajo pysähtyi. Muita yhdistämisiä ei peruutettu. Virhe:',
                open: 'Yhdistämishistoria',
                search: 'Hae nimellä tai tunnisteella',
                description:
                    'Koulun tehdyt yhdistämiset uusimmasta vanhimpaan. Voit tarvittaessa peruuttaa yhdistämisen, jos peruutusehdot täyttyvät.',
                created: 'Yhdistetty',
                primary: 'Päätili',
                source: 'Yhdistetty tili',
                status: 'Tila',
                cancellable: 'Peruutettavissa',
                cancellable_until: '%{date} asti',
                empty: 'Oppilaitokselle ei löytynyt yhdistämisiä.',
                load_error: 'Yhdistämishistorian haku epäonnistui.',
            },
            bulk: {
                report_export: '1. Vie tuplat Exceliin',
                report_completed: '3. Raportti koululle',
                report_workflow:
                    '1. Vie tarkistusehdotus Exceliin ja pyydä koululta hyväksyntä.\n2. Valitse hyväksytyt tilit, tarkista esikatselu ja yhdistä.\n3. Vie raportti toteutuneista yhdistämisistä koululle.',
                report_workflow_note:
                    'Koulu hyväksyy yhdistämiset järjestelmän ulkopuolella. Tehtyjä yhdistämisiä voi tarkastella ja peruuttaa historiassa.',
                report_title: 'Tuplatilien tarkistuslista',
                report_search: 'Listauksen hakurajaus',
                report_note:
                    'Tarkistusehdotus koululle, ei toteutettu yhdistäminen. Vienti sisältää kaikki hakua vastaavat ryhmät. Sisältää henkilötietoja: toimita vain asianomaiselle oppilaitokselle turvallista kanavaa käyttäen.',
                report_group: 'Ryhmä',
                report_name: 'Nimi',
                report_active_licenses: 'Koulun aktiivisia lisenssejä',
                report_valid_active_licenses:
                    'Koulun voimassa olevia aktiivisia lisenssejä',
                report_overlapping_licenses: 'Koulun päällekkäisiä aktiivisia lisenssirivejä ryhmässä',
                report_primary: 'Ehdotettu päätili',
                report_identifier: 'Säilytettävä kirjautumistunnus',
                report_status: 'Huomio',
                report_review: 'Vaatii erillisen selvityksen',
                report_proposal: 'Tarkistusehdotus',
                report_processed: 'Ryhmää on jo käsitelty. Päivitä tuplalista ennen uutta tarkistuskierrosta.',
                source_account: 'Yhdistettävä tili',
                merge_account: 'Avaa tunnuksen %{account} yhdistämisvälilehti (avautuu uuteen välilehteen)',
                search: 'Hae nimellä, sähköpostilla tai käyttäjätunnuksella',
                search_help:
                    'Haku etsii nimellä, sähköpostilla tai tunnuksella. Ryhmä näytetään, jos yksikin sen tileistä täsmää. Haun muutos tyhjentää valinnat.',
                filters_help:
                    'Suodattimet rajaavat ryhmiä kirjautumisen (1.8. alkaen) tai päällekkäisten lisenssien mukaan (valinnat toimivat OR-ehdolla). Suodattimen muutos tyhjentää valinnat.',
                no_search_results: 'Hakua vastaavia tuplaryhmiä ei löytynyt.',
                both_logged_in_this_season: 'Kaikki tilit kirjautuneet tällä kaudella',
                overlapping_licenses_only: 'Vain päällekkäisiä aktiivisia lisenssirivejä sisältävät',
                open: 'Yhdistä tuplat',
                title: 'Mahdollisten tuplatilien yhdistäminen',
                subtitle: 'Oppilaitos: %{school}',
                back: 'Takaisin listaukseen',
                invalid_context: 'Valitse ensin oppilaitos ja mahdolliset tuplat.',
                no_permission: 'Sinulla ei ole oikeutta yhdistää käyttäjiä.',
                load_error: 'Tuplatilien haku epäonnistui.',
                multiple_applications:
                    'Ryhmässä on tili, joka on liitetty useaan palveluun. Ryhmää ei voi yhdistää.',
                multiple_mpass:
                    'Vähintään kahdella ryhmän tilillä on MPASS. Kyseessä voivat olla täysnimikaimat, joten ryhmä on vain luettavissa eikä sitä voi massayhdistää. Selvitä ja käsittele tilit yksittäistapauksena käyttäjän profiilista.',
                group_count: 'Löytyi %{count} tuplaryhmää',
                group_count_header: 'Ryhmien määrä',
                accounts_count: '%{count} tiliä',
                overlapping_licenses: 'Päällekkäisiä aktiivisia lisenssirivejä: %{count}',
                overlapping_groups: 'Päällekkäisiä ryhmiä: %{count}',
                overlapping_license: 'Päällekkäinen aktiivinen lisenssirivi',
                overlapping_group: 'Päällekkäinen ryhmä',
                groups: 'Ryhmät',
                account_details_help:
                    'Rivin tiedoissa näkyvät tilin aktiiviset lisenssit ja ryhmät (ei arkistoituja). Koulun päällekkäiset lisenssit korostetaan keltaisella ja yhteiset ryhmät sinisellä.',
                sort: 'Järjestä ryhmät',
                sort_last_login_help: 'Näyttää ensin ryhmät, joissa on viimeksi käytetty tili. Vertailussa käytetään ryhmän uusinta kirjautumista. Järjestys siirtyy myös Exceliin.',
                sort_licenses_help:
                    'Näyttää ensin ryhmät, joissa on eniten voimassa olevia lisenssejä. Päivittää myös ehdotuksen säilytettäväksi päätiliksi (tasatilanteessa viimeksi käytetty).',
                sort_registered_help: 'Näyttää ensin ryhmät, joissa on uusimmin rekisteröitynyt tili. Vertailussa käytetään ryhmän uusinta rekisteröitymistä. Järjestys siirtyy myös Exceliin.',
                sort_merge_help:
                    'Järjestä tuplat tarkastelua varten: Kirjautuminen (viimeisimmät ensin), Lisenssit (eniten voimassa olevia ensin) tai Rekisteröityminen (uusimmat ensin). Lisenssit-valinta päivittää myös säilytettävän tilin ehdotuksen.',
                sort_merge_reminder:
                    'Yhdistä vain koulun hyväksymät tilit. Varmista säilytettävä päätili ja kirjautumistunnus ennen yhdistämistä.',
                sort_export_help:
                    'Järjestys siirtyy Exceliin: Kirjautuminen (viimeisimmät ensin), Lisenssit (eniten voimassa olevia ensin) tai Rekisteröityminen (uusimmat ensin). Lisenssit-järjestys päivittää myös säilytettävän tilin ehdotuksen.',
                sort_last_login: 'Kirjautuminen',
                sort_licenses: 'Lisenssit',
                sort_registered: 'Rekisteröityminen',
                select_page: 'Valitse / poista sivun valinnat',
                no_groups: 'Valitusta oppilaitoksesta ei löytynyt tuplaryhmiä.',
                primary: 'Päätili',
                identifier: 'Säilytettävä tunniste',
                identifier_domain: 'Suosi sähköpostidomainia',
                identifier_domain_none: 'Ei domainvalintaa',
                identifier_domain_help:
                    'Domainvalinta asettaa kyseisen osoitteen säilytettäväksi tunnisteeksi ryhmissä, joissa on täsmälleen yksi vastaava tili.',
                account: 'Tunnus',
                last_login: 'Viimeisin kirjautuminen',
                account_age: 'Tilin ikä (vuotta)',
                licenses: 'Aktiivisia lisenssejä (kaikki tilaajat)',
                license_owner_school: 'tämä koulu',
                license_owner_other_school: 'toinen koulu: %{school}',
                license_owner_account: 'käyttäjän oma',
                license_owner_other_account: 'käyttäjän oma: %{account}',
                license_owner_unknown: 'tilaaja tuntematon',
                license_category_school: 'Tämän koulun',
                license_category_school_help:
                    'Tilaajana on valittu koulu.',
                license_category_school_release_help:
                    'Mahdollisesti vapautuvat lisenssit palautuvat koulun lisenssipooliin.',
                license_category_other_school: 'Toisen koulun',
                license_category_other_school_help:
                    'Tilaajana on toinen koulu.',
                license_category_own: 'Oma',
                license_category_own_help:
                    'Käyttäjän itse hankkima lisenssi.',
                license_category_unknown: 'Tuntematon',
                license_category_unknown_help:
                    'Lisenssin tilaajaa ei voitu tunnistaa.',
                license_validity_summary:
                    '%{valid} / %{active} aktiivisesta lisenssistä voimassa',
                license_currently_valid: 'Lisenssi voimassa nyt',
                license_not_currently_valid: 'Lisenssi ei ole voimassa nyt',
                show_details: 'Näytä lisätiedot',
                hide_details: 'Piilota lisätiedot',
                mpass: 'MPASS',
                license_names: 'Lisenssit',
                extended_license: 'Jatkettu lisenssi (%{count} versiota)',
                classes: 'Luokat',
                previous: 'Edellinen',
                next: 'Seuraava',
                page: 'Sivu %{current} / %{total}',
                preview: 'Esikatsele valinnat',
                merge_selected: 'Yhdistä valitut ryhmät (%{count})',
                preview_title: 'Yhdistämisen esikatselu',
                preview_notice:
                    'Esikatselu ei muuta tilejä. Tarkista tunnusparit ja varoitukset ennen vahvistamista.',
                preview_error: 'Esikatselu epäonnistui',
                merge_error: 'Yhdistäminen epäonnistui',
                results_error: 'Yhdistämisen tulosten haku epäonnistui',
                batch_finished: 'Valittujen ryhmien käsittely valmis.',
                result_success: 'Yhdistäminen onnistui',
                result_partial: 'Yhdistäminen jäi osittaiseksi',
                result_error: 'Yhdistäminen epäonnistui',
                result_cancelled: 'Yhdistäminen peruutettiin',
                retry: 'Päivitä ryhmä uudelleenyritystä varten',
            },
        },
    }
);

export default customFinnishMessages;
